!function(){// import { PhotoSwipe } from "photoswipe";
/*!
  * PhotoSwipe Lightbox 5.4.0 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  *//** @typedef {import('../photoswipe.js').Point} Point *//**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */function t(t,e,i){let s=document.createElement(e);return t&&(s.className=t),i&&i.appendChild(s),s}/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */function e(t,e,i){t.style.width="number"==typeof e?`${e}px`:e,t.style.height="number"==typeof i?`${i}px`:i}/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState *//** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */let i={IDLE:"idle",LOADING:"loading",LOADED:"loaded",ERROR:"error"};/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */function s(t,e,i=document){/** @type {HTMLElement[]} */let s=[];if(t instanceof Element)s=[t];else if(t instanceof NodeList||Array.isArray(t))s=Array.from(t);else{let n="string"==typeof t?t:e;n&&(s=Array.from(i.querySelectorAll(n)))}return s}/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */function n(){return!!(navigator.vendor&&navigator.vendor.match(/apple/i))}/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox *//** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../photoswipe.js').DataSource} DataSource *//** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData *//** @typedef {import('../slide/content.js').default} ContentDefault *//** @typedef {import('../slide/slide.js').default} Slide *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//** @typedef {import('../slide/zoom-level.js').default} ZoomLevel *//** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds *//**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 *//** @typedef {{ x?: number; y?: number }} Point *//**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 *//**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thubmnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thubmnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 *//**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 *//**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */class o{preventDefault(){this.defaultPrevented=!0}/**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */constructor(t,e){this.type=t,this.defaultPrevented=!1,e&&Object.assign(this,e)}}/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */class a{/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */addFilter(t,e,i=100){var s,n,o;this._filters[t]||(this._filters[t]=[]),null===(s=this._filters[t])||void 0===s||s.push({fn:e,priority:i}),null===(n=this._filters[t])||void 0===n||n.sort((t,e)=>t.priority-e.priority),null===(o=this.pswp)||void 0===o||o.addFilter(t,e,i)}/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */removeFilter(t,e){this._filters[t]&&(this._filters[t]=this._filters[t].filter(t=>t.fn!==e)),this.pswp&&this.pswp.removeFilter(t,e)}/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */applyFilters(t,...e){var i;return null===(i=this._filters[t])||void 0===i||i.forEach(t=>{// @ts-expect-error
e[0]=t.fn.apply(this,e)}),e[0]}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */on(t,e){var i,s;this._listeners[t]||(this._listeners[t]=[]),null===(i=this._listeners[t])||void 0===i||i.push(e),null===// also bind events to PhotoSwipe Core,
// if it's open.
(s=this.pswp)||void 0===s||s.on(t,e)}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */off(t,e){var i;this._listeners[t]&&(this._listeners[t]=this._listeners[t].filter(t=>e!==t)),null===(i=this.pswp)||void 0===i||i.off(t,e)}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */dispatch(t,e){var i;if(this.pswp)return this.pswp.dispatch(t,e);let s=/** @type {AugmentedEvent<T>} */new o(t,e);return null===(i=this._listeners[t])||void 0===i||i.forEach(t=>{t.call(this,s)}),s}constructor(){/**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */this._listeners={},/**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */this._filters={},/** @type {PhotoSwipe | undefined} */this.pswp=void 0,/** @type {PhotoSwipeOptions | undefined} */this.options=void 0}}class r{/**
   * @param {number} width
   * @param {number} height
   */setDisplayedSize(t,i){if(this.element){if("IMG"===this.element.tagName){var s;let i;// Use transform scale() to modify img placeholder size
// (instead of changing width/height directly).
// This helps with performance, specifically in iOS15 Safari.
e(this.element,250,"auto"),this.element.style.transformOrigin="0 0",this.element.style.transform=(i="translate3d(0px,0px,0)",s=t/250,i+=` scale3d(${s},${s},1)`)}else e(this.element,t,i)}}destroy(){var t;null!==(t=this.element)&&void 0!==t&&t.parentNode&&this.element.remove(),this.element=null}/**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */constructor(e,i){if(// Create placeholder
// (stretched thumbnail or simple div behind the main image)
/** @type {HTMLImageElement | HTMLDivElement | null} */this.element=t("pswp__img pswp__img--placeholder",e?"img":"div",i),e){let t=/** @type {HTMLImageElement} */this.element;t.decoding="async",t.alt="",t.src=e,t.setAttribute("role","presentation")}this.element.setAttribute("aria-hidden","true")}}/** @typedef {import('./slide.js').default} Slide *//** @typedef {import('./slide.js').SlideData} SlideData *//** @typedef {import('../core/base.js').default} PhotoSwipeBase *//** @typedef {import('../util/util.js').LoadState} LoadState */class h{removePlaceholder(){this.placeholder&&!this.keepPlaceholder()&&setTimeout(()=>{this.placeholder&&(this.placeholder.destroy(),this.placeholder=void 0)},1e3)}/**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */load(e,i){if(this.slide&&this.usePlaceholder()){if(this.placeholder){let t=this.placeholder.element;// Add placeholder to DOM if it was already created
t&&!t.parentElement&&this.slide.container.prepend(t)}else{let t=this.instance.applyFilters("placeholderSrc",!!this.data.msrc&&!!this.slide.isFirstSlide&&this.data.msrc,this);this.placeholder=new r(t,this.slide.container)}}(!this.element||i)&&!this.instance.dispatch("contentLoad",{content:this,isLazy:e}).defaultPrevented&&(this.isImageContent()?(this.element=t("pswp__img","img"),this.displayedImageWidth&&this.loadImage(e)):(this.element=t("pswp__content","div"),this.element.innerHTML=this.data.html||""),i&&this.slide&&this.slide.updateContentSize(!0))}/**
   * Preload image
   *
   * @param {boolean} isLazy
   */loadImage(t){var e,s;if(!this.isImageContent()||!this.element||this.instance.dispatch("contentLoadImage",{content:this,isLazy:t}).defaultPrevented)return;let n=/** @type HTMLImageElement */this.element;this.updateSrcsetSizes(),this.data.srcset&&(n.srcset=this.data.srcset),n.src=null!==(e=this.data.src)&&void 0!==e?e:"",n.alt=null!==(s=this.data.alt)&&void 0!==s?s:"",this.state=i.LOADING,n.complete?this.onLoaded():(n.onload=()=>{this.onLoaded()},n.onerror=()=>{this.onError()})}/**
   * Assign slide to content
   *
   * @param {Slide} slide
   */setSlide(t){this.slide=t,this.hasSlide=!0,this.instance=t.pswp}/**
   * Content load success handler
   */onLoaded(){this.state=i.LOADED,this.slide&&this.element&&(this.instance.dispatch("loadComplete",{slide:this.slide,content:this}),this.slide.isActive&&this.slide.heavyAppended&&!this.element.parentNode&&(this.append(),this.slide.updateContentSize(!0)),(this.state===i.LOADED||this.state===i.ERROR)&&this.removePlaceholder())}/**
   * Content load error handler
   */onError(){this.state=i.ERROR,this.slide&&(this.displayError(),this.instance.dispatch("loadComplete",{slide:this.slide,isError:!0,content:this}),this.instance.dispatch("loadError",{slide:this.slide,content:this}))}/**
   * @returns {Boolean} If the content is currently loading
   */isLoading(){return this.instance.applyFilters("isContentLoading",this.state===i.LOADING,this)}/**
   * @returns {Boolean} If the content is in error state
   */isError(){return this.state===i.ERROR}/**
   * @returns {boolean} If the content is image
   */isImageContent(){return"image"===this.type}/**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */setDisplayedSize(t,i){if(this.element&&(this.placeholder&&this.placeholder.setDisplayedSize(t,i),!this.instance.dispatch("contentResize",{content:this,width:t,height:i}).defaultPrevented&&(e(this.element,t,i),this.isImageContent()&&!this.isError()))){let e=!this.displayedImageWidth&&t;this.displayedImageWidth=t,this.displayedImageHeight=i,e?this.loadImage(!1):this.updateSrcsetSizes(),this.slide&&this.instance.dispatch("imageSizeChange",{slide:this.slide,width:t,height:i,content:this})}}/**
   * @returns {boolean} If the content can be zoomed
   */isZoomable(){return this.instance.applyFilters("isContentZoomable",this.isImageContent()&&this.state!==i.ERROR,this)}/**
   * Update image srcset sizes attribute based on width and height
   */updateSrcsetSizes(){// Handle srcset sizes attribute.
//
// Never lower quality, if it was increased previously.
// Chrome does this automatically, Firefox and Safari do not,
// so we store largest used size in dataset.
if(!this.isImageContent()||!this.element||!this.data.srcset)return;let t=/** @type HTMLImageElement */this.element,e=this.instance.applyFilters("srcsetSizesWidth",this.displayedImageWidth,this);(!t.dataset.largestUsedSize||e>parseInt(t.dataset.largestUsedSize,10))&&(t.sizes=e+"px",t.dataset.largestUsedSize=String(e))}/**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */usePlaceholder(){return this.instance.applyFilters("useContentPlaceholder",this.isImageContent(),this)}/**
   * Preload content with lazy-loading param
   */lazyLoad(){this.instance.dispatch("contentLazyLoad",{content:this}).defaultPrevented||this.load(!0)}/**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */keepPlaceholder(){return this.instance.applyFilters("isKeepingPlaceholder",this.isLoading(),this)}/**
   * Destroy the content
   */destroy(){this.hasSlide=!1,this.slide=void 0,!this.instance.dispatch("contentDestroy",{content:this}).defaultPrevented&&(this.remove(),this.placeholder&&(this.placeholder.destroy(),this.placeholder=void 0),this.isImageContent()&&this.element&&(this.element.onload=null,this.element.onerror=null,this.element=void 0))}/**
   * Display error message
   */displayError(){if(this.slide){var e,i;let s=t("pswp__error-msg","div");s.innerText=null!==(e=null===(i=this.instance.options)||void 0===i?void 0:i.errorMsg)&&void 0!==e?e:"",s=/** @type {HTMLDivElement} */this.instance.applyFilters("contentErrorElement",s,this),this.element=t("pswp__content pswp__error-msg-container","div"),this.element.appendChild(s),this.slide.container.innerText="",this.slide.container.appendChild(this.element),this.slide.updateContentSize(!0),this.removePlaceholder()}}/**
   * Append the content
   */append(){if(this.isAttached||!this.element)return;if(this.isAttached=!0,this.state===i.ERROR){this.displayError();return}if(this.instance.dispatch("contentAppend",{content:this}).defaultPrevented)return;let t="decode"in this.element;this.isImageContent()?t&&this.slide&&(!this.slide.isActive||n())?(this.isDecoding=!0,// as if srcset sizes changes dynamically - it may cause decode error
/** @type {HTMLImageElement} */this.element.decode().catch(()=>{}).finally(()=>{this.isDecoding=!1,this.appendImage()})):this.appendImage():this.slide&&!this.element.parentNode&&this.slide.container.appendChild(this.element)}/**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */activate(){!this.instance.dispatch("contentActivate",{content:this}).defaultPrevented&&this.slide&&(this.isImageContent()&&this.isDecoding&&!n()?// even if it's not finished decoding
this.appendImage():this.isError()&&this.load(!1,!0),this.slide.holderElement&&this.slide.holderElement.setAttribute("aria-hidden","false"))}/**
   * Deactivate the content
   */deactivate(){this.instance.dispatch("contentDeactivate",{content:this}),this.slide&&this.slide.holderElement&&this.slide.holderElement.setAttribute("aria-hidden","true")}/**
   * Remove the content from DOM
   */remove(){this.isAttached=!1,!this.instance.dispatch("contentRemove",{content:this}).defaultPrevented&&(this.element&&this.element.parentNode&&this.element.remove(),this.placeholder&&this.placeholder.element&&this.placeholder.element.remove())}/**
   * Append the image content to slide container
   */appendImage(){this.isAttached&&(this.instance.dispatch("contentAppendImage",{content:this}).defaultPrevented||(this.slide&&this.element&&!this.element.parentNode&&this.slide.container.appendChild(this.element),(this.state===i.LOADED||this.state===i.ERROR)&&this.removePlaceholder()))}/**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */constructor(t,e,s){this.instance=e,this.data=t,this.index=s,/** @type {HTMLImageElement | HTMLDivElement | undefined} */this.element=void 0,/** @type {Placeholder | undefined} */this.placeholder=void 0,/** @type {Slide | undefined} */this.slide=void 0,this.displayedImageWidth=0,this.displayedImageHeight=0,this.width=Number(this.data.w)||Number(this.data.width)||0,this.height=Number(this.data.h)||Number(this.data.height)||0,this.isAttached=!1,this.hasSlide=!1,this.isDecoding=!1,/** @type {LoadState} */this.state=i.IDLE,this.data.type?this.type=this.data.type:this.data.src?this.type="image":this.type="html",this.instance.dispatch("contentInit",{content:this})}}/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */function l(t,e,i,s,n){let o=0;if(e.paddingFn)o=e.paddingFn(i,s,n)[t];else if(e.padding)o=e.padding[t];else{let i="padding"+t[0].toUpperCase()+t.slice(1);// @ts-expect-error
e[i]&&(o=e[i])}return Number(o)||0}/** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption *//**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */class d{/**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */update(t,e,i){/** @type {Point} */let s={x:t,y:e};this.elementSize=s,this.panAreaSize=i;let n=i.x/s.x,o=i.y/s.y;this.fit=Math.min(1,n<o?n:o),this.fill=Math.min(1,n>o?n:o),// when it has 100% of viewport vertical space (height)
this.vFill=Math.min(1,o),this.initial=this._getInitial(),this.secondary=this._getSecondary(),this.max=Math.max(this.initial,this.secondary,this._getMax()),this.min=Math.min(this.fit,this.initial,this.secondary),this.pswp&&this.pswp.dispatch("zoomLevelsUpdate",{zoomLevels:this,slideData:this.itemData})}/**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */_parseZoomLevelOption(t){let e=this.options[/** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */t+"ZoomLevel"];if(e)return"function"==typeof e?e(this):"fill"===e?this.fill:"fit"===e?this.fit:Number(e)}/**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */_getSecondary(){let t=this._parseZoomLevelOption("secondary");return t||(// 3x of "fit" state, but not larger than original
t=Math.min(1,3*this.fit),this.elementSize&&t*this.elementSize.x>4e3&&(t=4e3/this.elementSize.x)),t}/**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */_getInitial(){return this._parseZoomLevelOption("initial")||this.fit}/**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */_getMax(){// max zoom level is x4 from "fit state",
// used for zoom gesture and ctrl/trackpad zoom
return this._parseZoomLevelOption("max")||Math.max(1,4*this.fit)}/**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */constructor(t,e,i,s){this.pswp=s,this.options=t,this.itemData=e,this.index=i,/** @type { Point | null } */this.panAreaSize=null,/** @type { Point | null } */this.elementSize=null,this.fit=1,this.fill=1,this.vFill=1,this.initial=1,this.secondary=1,this.max=1,this.min=1}}/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */function p(t,e,i){let s;let n=e.createContentFromData(t,i),{options:o}=e;// as it might use srcset, and we need to define sizes
if(o){let a;s=new d(o,t,-1),a=e.pswp?e.pswp.viewportSize:/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../core/base.js').default} PhotoSwipeBase *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */function(t,e){if(t.getViewportSizeFn){let i=t.getViewportSizeFn(t,e);if(i)return i}return{x:document.documentElement.clientWidth,// TODO: height on mobile is very incosistent due to toolbar
// find a way to improve this
//
// document.documentElement.clientHeight - doesn't seem to work well
y:window.innerHeight}}(o,e);let r={x:a.x-l("left",o,a,t,i)-l("right",o,a,t,i),y:a.y-l("top",o,a,t,i)-l("bottom",o,a,t,i)};s.update(n.width,n.height,r)}return n.lazyLoad(),s&&n.setDisplayedSize(Math.ceil(n.width*s.initial),Math.ceil(n.height*s.initial)),n}/** @typedef {import("../photoswipe.js").default} PhotoSwipe *//** @typedef {import("../slide/slide.js").SlideData} SlideData *//**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */class c extends a{/**
   * Get total number of slides
   *
   * @returns {number}
   */getNumItems(){var t;let e=0,i=null===(t=this.options)||void 0===t?void 0:t.dataSource;i&&"length"in i?e=i.length:i&&"gallery"in i&&(i.items||(i.items=this._getGalleryDOMElements(i.gallery)),i.items&&(e=i.items.length));// legacy event, before filters were introduced
let s=this.dispatch("numItems",{dataSource:i,numItems:e});return this.applyFilters("numItems",s.numItems,i)}/**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */createContentFromData(t,e){return new h(t,this,e)}/**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */getItemData(t){var e;let i=null===(e=this.options)||void 0===e?void 0:e.dataSource,s={};Array.isArray(i)?s=i[t]:i&&"gallery"in i&&(i.items||(i.items=this._getGalleryDOMElements(i.gallery)),s=i.items[t]);let n=s;n instanceof Element&&(n=this._domElementToItemData(n));// Dispatching the itemData event,
// it's a legacy verion before filters were introduced
let o=this.dispatch("itemData",{itemData:n||{},index:t});return this.applyFilters("itemData",o.itemData,t)}/**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */_getGalleryDOMElements(t){var e,i;return null!==(e=this.options)&&void 0!==e&&e.children||null!==(i=this.options)&&void 0!==i&&i.childSelector?s(this.options.children,this.options.childSelector,t)||[]:[t]}/**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */_domElementToItemData(t){/** @type {SlideData} */let e={element:t},i=/** @type {HTMLAnchorElement} */"A"===t.tagName?t:t.querySelector("a");if(i){// src comes from data-pswp-src attribute,
// if it's empty link href is used
e.src=i.dataset.pswpSrc||i.href,i.dataset.pswpSrcset&&(e.srcset=i.dataset.pswpSrcset),e.width=i.dataset.pswpWidth?parseInt(i.dataset.pswpWidth,10):0,e.height=i.dataset.pswpHeight?parseInt(i.dataset.pswpHeight,10):0,e.w=e.width,e.h=e.height,i.dataset.pswpType&&(e.type=i.dataset.pswpType);let n=t.querySelector("img");if(n){var s;// msrc is URL to placeholder image that's displayed before large image is loaded
// by default it's displayed only for the first slide
e.msrc=n.currentSrc||n.src,e.alt=null!==(s=n.getAttribute("alt"))&&void 0!==s?s:""}(i.dataset.pswpCropped||i.dataset.cropped)&&(e.thumbCropped=!0)}return this.applyFilters("domItemData",e,t,i)}/**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */lazyLoadData(t,e){return p(t,this,e)}}/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 *//** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../photoswipe.js').DataSource} DataSource *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {import('../slide/content.js').default} Content *//** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap *//** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 *//**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */class m extends c{/**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */init(){// Bind click events to each gallery
s(this.options.gallery,this.options.gallerySelector).forEach(t=>{t.addEventListener("click",this.onThumbnailsClick,!1)})}/**
   * @param {MouseEvent} e
   */onThumbnailsClick(t){// Exit and allow default browser action if:
if("button"in t&&1===t.button||t.ctrlKey||t.metaKey||t.altKey||t.shiftKey||window.pswp)return;// If both clientX and clientY are 0 or not defined,
// the event is likely triggered by keyboard,
// so we do not pass the initialPoint
//
// Note that some screen readers emulate the mouse position,
// so it's not the ideal way to detect them.
//
/** @type {Point | null} */let e={x:t.clientX,y:t.clientY};e.x||e.y||(e=null);let i=this.getClickedIndex(t);i=this.applyFilters("clickedIndex",i,t,this);/** @type {DataSource} */let s={gallery:/** @type {HTMLElement} */t.currentTarget};i>=0&&(t.preventDefault(),this.loadAndOpen(i,s,e))}/**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */getClickedIndex(t){// legacy option
if(this.options.getClickedIndexFn)return this.options.getClickedIndexFn.call(this,t);let e=/** @type {HTMLElement} */t.target,i=s(this.options.children,this.options.childSelector,/** @type {HTMLElement} */t.currentTarget),n=i.findIndex(t=>t===e||t.contains(e));return -1!==n?n:this.options.children||this.options.childSelector?-1:0}/**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} dataSource
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */loadAndOpen(t,e,i){return(// Check if the gallery is already open
!window.pswp&&(// set initial index
this.options.index=t,this.options.initialPointerPos=i,this.shouldOpen=!0,this.preload(t,e),!0))}/**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */preload(t,e){var i;let{options:s}=this;e&&(s.dataSource=e);// Add the main module
/** @type {Promise<Type<PhotoSwipe>>[]} */let n=[],o=typeof s.pswpModule;if("function"==typeof(i=s.pswpModule)&&i.prototype&&i.prototype.goTo)n.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */s.pswpModule));else if("string"===o)throw Error("pswpModule as string is no longer supported");else if("function"===o)n.push(/** @type {() => Promise<Type<PhotoSwipe>>} */s.pswpModule());else throw Error("pswpModule is not valid");"function"==typeof s.openPromise&&n.push(s.openPromise()),!1!==s.preloadFirstSlide&&t>=0&&(this._preloadedContent=/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */function(t,e){let i=e.getItemData(t);if(!e.dispatch("lazyLoadSlide",{index:t,itemData:i}).defaultPrevented)return p(i,e,t)}(t,this));// Wait till all promises resolve and open PhotoSwipe
let a=++this._uid;Promise.all(n).then(t=>{if(this.shouldOpen){let e=t[0];this._openPhotoswipe(e,a)}})}/**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */_openPhotoswipe(t,e){// Cancel opening if UID doesn't match the current one
// (if user clicked on another gallery item before current was loaded).
//
// Or if shouldOpen flag is set to false
// (developer may modify it via public API)
if(e!==this._uid&&this.shouldOpen||(this.shouldOpen=!1,window.pswp))return;/**
     * Pass data to PhotoSwipe and open init
     *
     * @type {PhotoSwipe}
     */let i="object"==typeof t?new t.default(this.options)// eslint-disable-line
:new t(this.options);// eslint-disable-line
this.pswp=i,window.pswp=i,/** @type {(keyof PhotoSwipeEventsMap)[]} */Object.keys(this._listeners).forEach(t=>{var e;null===(e=this._listeners[t])||void 0===e||e.forEach(e=>{i.on(t,/** @type {EventCallback<typeof name>} */e)})}),/** @type {(keyof PhotoSwipeFiltersMap)[]} */Object.keys(this._filters).forEach(t=>{var e;null===(e=this._filters[t])||void 0===e||e.forEach(e=>{i.addFilter(t,e.fn,e.priority)})}),this._preloadedContent&&(i.contentLoader.addToCache(this._preloadedContent),this._preloadedContent=void 0),i.on("destroy",()=>{// clean up public variables
this.pswp=void 0,delete window.pswp}),i.init()}/**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */destroy(){var t;null===(t=this.pswp)||void 0===t||t.destroy(),this.shouldOpen=!1,this._listeners={},s(this.options.gallery,this.options.gallerySelector).forEach(t=>{t.removeEventListener("click",this.onThumbnailsClick,!1)})}/**
   * @param {PhotoSwipeOptions} [options]
   */constructor(t){super(),/** @type {PhotoSwipeOptions} */this.options=t||{},this._uid=0,this.shouldOpen=!1,/**
     * @private
     * @type {Content | undefined}
     */this._preloadedContent=void 0,this.onThumbnailsClick=this.onThumbnailsClick.bind(this)}}function u(t,e,i){let s=document.createElement(e);return t&&(s.className=t),i&&i.appendChild(s),s}/**
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */function v(t,e){return t.x=e.x,t.y=e.y,void 0!==e.id&&(t.id=e.id),t}/**
 * @param {Point} p
 */function g(t){t.x=Math.round(t.x),t.y=Math.round(t.y)}/**
 * Returns distance between two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {number}
 */function _(t,e){let i=Math.abs(t.x-e.x),s=Math.abs(t.y-e.y);return Math.sqrt(i*i+s*s)}/**
 * Whether X and Y positions of points are equal
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {boolean}
 */function y(t,e){return t.x===e.x&&t.y===e.y}/**
 * The float result between the min and max values.
 *
 * @param {number} val
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */function f(t,e,i){return Math.min(Math.max(t,e),i)}/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */function w(t,e,i){let s=`translate3d(${t}px,${e||0}px,0)`;return void 0!==i&&(s+=` scale3d(${i},${i},1)`),s}/**
 * Apply transform:translate(x, y) scale(scale) to element
 *
 * @param {HTMLElement} el
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 */function S(t,e,i,s){t.style.transform=w(e,i,s)}/**
 * Apply CSS transition to element
 *
 * @param {HTMLElement} el
 * @param {string} [prop] CSS property to animate
 * @param {number} [duration] in ms
 * @param {string} [ease] CSS easing function
 */function x(t,e,i,s){// inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
// out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
// in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
t.style.transition=e?`${e} ${i}ms ${s||"cubic-bezier(.4,0,.22,1)"}`:"none"}/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */function P(t,e,i){t.style.width="number"==typeof e?`${e}px`:e,t.style.height="number"==typeof i?`${i}px`:i}/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState *//** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */let b={IDLE:"idle",LOADING:"loading",LOADED:"loaded",ERROR:"error"};/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */function C(){return!!(navigator.vendor&&navigator.vendor.match(/apple/i))}// Detect passive event listener support
let I=!1;/* eslint-disable */try{/* @ts-ignore */window.addEventListener("test",null,Object.defineProperty({},"passive",{get:()=>{I=!0}}))}catch(t){}/* eslint-enable *//**
 * @typedef {Object} PoolItem
 * @prop {HTMLElement | Window | Document | undefined | null} target
 * @prop {string} type
 * @prop {EventListenerOrEventListenerObject} listener
 * @prop {boolean} [passive]
 */class L{/**
   * Adds event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type Can be multiple, separated by space.
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */add(t,e,i,s){this._toggleListener(t,e,i,s)}/**
   * Removes event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */remove(t,e,i,s){this._toggleListener(t,e,i,s,!0)}/**
   * Removes all bound events
   */removeAll(){this._pool.forEach(t=>{this._toggleListener(t.target,t.type,t.listener,t.passive,!0,!0)}),this._pool=[]}/**
   * Adds or removes event
   *
   * @private
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   * @param {boolean} [unbind] Whether the event should be added or removed
   * @param {boolean} [skipPool] Whether events pool should be skipped
   */_toggleListener(t,e,i,s,n,o){if(!t)return;let a=n?"removeEventListener":"addEventListener",r=e.split(" ");r.forEach(e=>{if(e){// Events pool is used to easily unbind all events when PhotoSwipe is closed,
// so developer doesn't need to do this manually
o||(n?this._pool=this._pool.filter(s=>s.type!==e||s.listener!==i||s.target!==t):this._pool.push({target:t,type:e,listener:i,passive:s}));// most PhotoSwipe events call preventDefault,
// and we do not need browser to scroll the page
let r=!!I&&{passive:s||!1};t[a](e,i,r)}})}constructor(){/**
     * @type {PoolItem[]}
     * @private
     */this._pool=[]}}/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../core/base.js').default} PhotoSwipeBase *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */function A(t,e){if(t.getViewportSizeFn){let i=t.getViewportSizeFn(t,e);if(i)return i}return{x:document.documentElement.clientWidth,// TODO: height on mobile is very incosistent due to toolbar
// find a way to improve this
//
// document.documentElement.clientHeight - doesn't seem to work well
y:window.innerHeight}}/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */function z(t,e,i,s,n){let o=0;if(e.paddingFn)o=e.paddingFn(i,s,n)[t];else if(e.padding)o=e.padding[t];else{let i="padding"+t[0].toUpperCase()+t.slice(1);// @ts-expect-error
e[i]&&(o=e[i])}return Number(o)||0}/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */function T(t,e,i,s){return{x:e.x-z("left",t,e,i,s)-z("right",t,e,i,s),y:e.y-z("top",t,e,i,s)-z("bottom",t,e,i,s)}}/** @typedef {import('./slide.js').default} Slide *//** @typedef {Record<Axis, number>} Point *//** @typedef {'x' | 'y'} Axis *//**
 * Calculates minimum, maximum and initial (center) bounds of a slide
 */class E{/**
   * _getItemBounds
   *
   * @param {number} currZoomLevel
   */update(t){this.currZoomLevel=t,this.slide.width?(this._updateAxis("x"),this._updateAxis("y"),this.slide.pswp.dispatch("calcBounds",{slide:this.slide})):this.reset()}/**
   * _calculateItemBoundsForAxis
   *
   * @param {Axis} axis
   */_updateAxis(t){let{pswp:e}=this.slide,i=this.slide["x"===t?"width":"height"]*this.currZoomLevel,s=z("x"===t?"left":"top",e.options,e.viewportSize,this.slide.data,this.slide.index),n=this.slide.panAreaSize[t];// By default, it is center of viewport:
this.center[t]=Math.round((n-i)/2)+s,this.max[t]=i>n?Math.round(n-i)+s:this.center[t],this.min[t]=i>n?s:this.center[t]}reset(){this.center.x=0,this.center.y=0,this.max.x=0,this.max.y=0,this.min.x=0,this.min.y=0}/**
   * Correct pan position if it's beyond the bounds
   *
   * @param {Axis} axis x or y
   * @param {number} panOffset
   * @returns {number}
   */correctPan(t,e){// checkPanBounds
return f(e,this.max[t],this.min[t])}/**
   * @param {Slide} slide
   */constructor(t){this.slide=t,this.currZoomLevel=1,this.center=/** @type {Point} */{x:0,y:0},this.max=/** @type {Point} */{x:0,y:0},this.min=/** @type {Point} */{x:0,y:0}}}/** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption *//**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */class D{/**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */update(t,e,i){/** @type {Point} */let s={x:t,y:e};this.elementSize=s,this.panAreaSize=i;let n=i.x/s.x,o=i.y/s.y;this.fit=Math.min(1,n<o?n:o),this.fill=Math.min(1,n>o?n:o),// when it has 100% of viewport vertical space (height)
this.vFill=Math.min(1,o),this.initial=this._getInitial(),this.secondary=this._getSecondary(),this.max=Math.max(this.initial,this.secondary,this._getMax()),this.min=Math.min(this.fit,this.initial,this.secondary),this.pswp&&this.pswp.dispatch("zoomLevelsUpdate",{zoomLevels:this,slideData:this.itemData})}/**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */_parseZoomLevelOption(t){let e=this.options[/** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */t+"ZoomLevel"];if(e)return"function"==typeof e?e(this):"fill"===e?this.fill:"fit"===e?this.fit:Number(e)}/**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */_getSecondary(){let t=this._parseZoomLevelOption("secondary");return t||(// 3x of "fit" state, but not larger than original
t=Math.min(1,3*this.fit),this.elementSize&&t*this.elementSize.x>4e3&&(t=4e3/this.elementSize.x)),t}/**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */_getInitial(){return this._parseZoomLevelOption("initial")||this.fit}/**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */_getMax(){// max zoom level is x4 from "fit state",
// used for zoom gesture and ctrl/trackpad zoom
return this._parseZoomLevelOption("max")||Math.max(1,4*this.fit)}/**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */constructor(t,e,i,s){this.pswp=s,this.options=t,this.itemData=e,this.index=i,/** @type { Point | null } */this.panAreaSize=null,/** @type { Point | null } */this.elementSize=null,this.fit=1,this.fill=1,this.vFill=1,this.initial=1,this.secondary=1,this.max=1,this.min=1}}/** @typedef {import('../photoswipe.js').default} PhotoSwipe *//**
 * Renders and allows to control a single slide
 */class O{/**
   * If this slide is active/current/visible
   *
   * @param {boolean} isActive
   */setIsActive(t){t&&!this.isActive?this.activate():!t&&this.isActive&&this.deactivate()}/**
   * Appends slide content to DOM
   *
   * @param {HTMLElement} holderElement
   */append(t){this.holderElement=t,this.container.style.transformOrigin="0 0",this.data&&(this.calculateSize(),this.load(),this.updateContentSize(),this.appendHeavy(),this.holderElement.appendChild(this.container),this.zoomAndPanToInitial(),this.pswp.dispatch("firstZoomPan",{slide:this}),this.applyCurrentZoomPan(),this.pswp.dispatch("afterSetContent",{slide:this}),this.isActive&&this.activate())}load(){this.content.load(!1),this.pswp.dispatch("slideLoad",{slide:this})}/**
   * Append "heavy" DOM elements
   *
   * This may depend on a type of slide,
   * but generally these are large images.
   */appendHeavy(){let{pswp:t}=this;// Avoid appending heavy elements during animations
this.heavyAppended||!t.opener.isOpen||t.mainScroll.isShifted()||(this.isActive,0)||this.pswp.dispatch("appendHeavy",{slide:this}).defaultPrevented||(this.heavyAppended=!0,this.content.append(),this.pswp.dispatch("appendHeavyContent",{slide:this}))}/**
   * Triggered when this slide is active (selected).
   *
   * If it's part of opening/closing transition -
   * activate() will trigger after the transition is ended.
   */activate(){this.isActive=!0,this.appendHeavy(),this.content.activate(),this.pswp.dispatch("slideActivate",{slide:this})}/**
   * Triggered when this slide becomes inactive.
   *
   * Slide can become inactive only after it was active.
   */deactivate(){this.isActive=!1,this.content.deactivate(),this.currZoomLevel!==this.zoomLevels.initial&&this.calculateSize(),// reset zoom level
this.currentResolution=0,this.zoomAndPanToInitial(),this.applyCurrentZoomPan(),this.updateContentSize(),this.pswp.dispatch("slideDeactivate",{slide:this})}/**
   * The slide should destroy itself, it will never be used again.
   * (unbind all events and destroy internal components)
   */destroy(){this.content.hasSlide=!1,this.content.remove(),this.container.remove(),this.pswp.dispatch("slideDestroy",{slide:this})}resize(){this.currZoomLevel!==this.zoomLevels.initial&&this.isActive?(// readjust pan position if it's beyond the bounds
this.calculateSize(),this.bounds.update(this.currZoomLevel),this.panTo(this.pan.x,this.pan.y)):(// Keep initial zoom level if it was before the resize,
// as well as when this slide is not active
// Reset position and scale to original state
this.calculateSize(),this.currentResolution=0,this.zoomAndPanToInitial(),this.applyCurrentZoomPan(),this.updateContentSize())}/**
   * Apply size to current slide content,
   * based on the current resolution and scale.
   *
   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
   */updateContentSize(t){// Use initial zoom level
// if resolution is not defined (user didn't zoom yet)
let e=this.currentResolution||this.zoomLevels.initial;if(!e)return;let i=Math.round(this.width*e)||this.pswp.viewportSize.x,s=Math.round(this.height*e)||this.pswp.viewportSize.y;(this.sizeChanged(i,s)||t)&&this.content.setDisplayedSize(i,s)}/**
   * @param {number} width
   * @param {number} height
   */sizeChanged(t,e){return(t!==this.prevDisplayedWidth||e!==this.prevDisplayedHeight)&&(this.prevDisplayedWidth=t,this.prevDisplayedHeight=e,!0)}/** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */getPlaceholderElement(){var t;return null===(t=this.content.placeholder)||void 0===t?void 0:t.element}/**
   * Zoom current slide image to...
   *
   * @param {number} destZoomLevel Destination zoom level.
   * @param {Point} [centerPoint]
   * Transform origin center point, or false if viewport center should be used.
   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
   */zoomTo(t,e,i,s){let{pswp:n}=this;if(!this.isZoomable()||n.mainScroll.isShifted())return;n.dispatch("beforeZoomTo",{destZoomLevel:t,centerPoint:e,transitionDuration:i}),n.animations.stopAllPan();//   centerPoint = pswp.getViewportCenterPoint();
// }
let o=this.currZoomLevel;s||(t=f(t,this.zoomLevels.min,this.zoomLevels.max)),// if (transitionDuration === undefined) {
//   transitionDuration = this.pswp.options.zoomAnimationDuration;
// }
this.setZoomLevel(t),this.pan.x=this.calculateZoomToPanOffset("x",e,o),this.pan.y=this.calculateZoomToPanOffset("y",e,o),g(this.pan);let a=()=>{this._setResolution(t),this.applyCurrentZoomPan()};i?n.animations.startTransition({isPan:!0,name:"zoomTo",target:this.container,transform:this.getCurrentTransform(),onComplete:a,duration:i,easing:n.options.easing}):a()}/**
   * @param {Point} [centerPoint]
   */toggleZoom(t){this.zoomTo(this.currZoomLevel===this.zoomLevels.initial?this.zoomLevels.secondary:this.zoomLevels.initial,t,this.pswp.options.zoomAnimationDuration)}/**
   * Updates zoom level property and recalculates new pan bounds,
   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
   *
   * @param {number} currZoomLevel
   */setZoomLevel(t){this.currZoomLevel=t,this.bounds.update(this.currZoomLevel)}/**
   * Get pan position after zoom at a given `point`.
   *
   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
   * pan bounds according to the new zoom level.
   *
   * @param {'x' | 'y'} axis
   * @param {Point} [point]
   * point based on which zoom is performed, usually refers to the current mouse position,
   * if false - viewport center will be used.
   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
   * @returns {number}
   */calculateZoomToPanOffset(t,e,i){let s=this.bounds.max[t]-this.bounds.min[t];if(0===s)return this.bounds.center[t];e||(e=this.pswp.getViewportCenterPoint()),i||(i=this.zoomLevels.initial);let n=this.currZoomLevel/i;return this.bounds.correctPan(t,(this.pan[t]-e[t])*n+e[t])}/**
   * Apply pan and keep it within bounds.
   *
   * @param {number} panX
   * @param {number} panY
   */panTo(t,e){this.pan.x=this.bounds.correctPan("x",t),this.pan.y=this.bounds.correctPan("y",e),this.applyCurrentZoomPan()}/**
   * If the slide in the current state can be panned by the user
   * @returns {boolean}
   */isPannable(){return!!this.width&&this.currZoomLevel>this.zoomLevels.fit}/**
   * If the slide can be zoomed
   * @returns {boolean}
   */isZoomable(){return!!this.width&&this.content.isZoomable()}/**
   * Apply transform and scale based on
   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
   */applyCurrentZoomPan(){this._applyZoomTransform(this.pan.x,this.pan.y,this.currZoomLevel),this===this.pswp.currSlide&&this.pswp.dispatch("zoomPanUpdate",{slide:this})}zoomAndPanToInitial(){this.currZoomLevel=this.zoomLevels.initial,this.bounds.update(this.currZoomLevel),v(this.pan,this.bounds.center),this.pswp.dispatch("initialZoomPan",{slide:this})}/**
   * Set translate and scale based on current resolution
   *
   * @param {number} x
   * @param {number} y
   * @param {number} zoom
   * @private
   */_applyZoomTransform(t,e,i){i/=this.currentResolution||this.zoomLevels.initial,S(this.container,t,e,i)}calculateSize(){let{pswp:t}=this;v(this.panAreaSize,T(t.options,t.viewportSize,this.data,this.index)),this.zoomLevels.update(this.width,this.height,this.panAreaSize),t.dispatch("calcSlideSize",{slide:this})}/** @returns {string} */getCurrentTransform(){let t=this.currZoomLevel/(this.currentResolution||this.zoomLevels.initial);return w(this.pan.x,this.pan.y,t)}/**
   * Set resolution and re-render the image.
   *
   * For example, if the real image size is 2000x1500,
   * and resolution is 0.5 - it will be rendered as 1000x750.
   *
   * Image with zoom level 2 and resolution 0.5 is
   * the same as image with zoom level 1 and resolution 1.
   *
   * Used to optimize animations and make
   * sure that browser renders image in the highest quality.
   * Also used by responsive images to load the correct one.
   *
   * @param {number} newResolution
   */_setResolution(t){t!==this.currentResolution&&(this.currentResolution=t,this.updateContentSize(),this.pswp.dispatch("resolutionChanged"))}/**
   * @param {SlideData} data
   * @param {number} index
   * @param {PhotoSwipe} pswp
   */constructor(t,e,i){this.data=t,this.index=e,this.pswp=i,this.isActive=e===i.currIndex,this.currentResolution=0,/** @type {Point} */this.panAreaSize={x:0,y:0},/** @type {Point} */this.pan={x:0,y:0},this.isFirstSlide=this.isActive&&!i.opener.isOpen,this.zoomLevels=new D(i.options,t,e,i),this.pswp.dispatch("gettingData",{slide:this,data:this.data,index:e}),this.content=this.pswp.contentLoader.getContentBySlide(this),this.container=u("pswp__zoom-wrap","div"),/** @type {HTMLElement | null} */this.holderElement=null,this.currZoomLevel=1,/** @type {number} */this.width=this.content.width,/** @type {number} */this.height=this.content.height,this.heavyAppended=!1,this.bounds=new E(this),this.prevDisplayedWidth=-1,this.prevDisplayedHeight=-1,this.pswp.dispatch("slideInit",{slide:this})}}/**
 * Handles single pointer dragging
 */class Z{start(){this.pswp.currSlide&&v(this.startPan,this.pswp.currSlide.pan),this.pswp.animations.stopAll()}change(){let{p1:t,prevP1:e,dragAxis:i}=this.gestures,{currSlide:s}=this.pswp;if("y"===i&&this.pswp.options.closeOnVerticalDrag&&s&&s.currZoomLevel<=s.zoomLevels.fit&&!this.gestures.isMultitouch){// Handle vertical drag to close
let i=s.pan.y+(t.y-e.y);if(!this.pswp.dispatch("verticalDrag",{panY:i}).defaultPrevented){this._setPanWithFriction("y",i,.6);let t=1-Math.abs(this._getVerticalDragRatio(s.pan.y));this.pswp.applyBgOpacity(t),s.applyCurrentZoomPan()}}else{let t=this._panOrMoveMainScroll("x");!t&&(this._panOrMoveMainScroll("y"),s&&(g(s.pan),s.applyCurrentZoomPan()))}}end(){let{velocity:t}=this.gestures,{mainScroll:e,currSlide:i}=this.pswp,s=0;if(this.pswp.animations.stopAll(),e.isShifted()){// Position of the main scroll relative to the viewport
let i=e.x-e.getCurrSlideX(),n=i/this.pswp.viewportSize.x;// Ratio between 0 and 1:
t.x<-.5&&n<0||t.x<.1&&n<-.5?(// Go to next slide
s=1,t.x=Math.min(t.x,0)):(t.x>.5&&n>0||t.x>-.1&&n>.5)&&(// Go to prev slide
s=-1,t.x=Math.max(t.x,0)),e.moveIndexBy(s,!0,t.x)}// Restore zoom level
i&&i.currZoomLevel>i.zoomLevels.max||this.gestures.isMultitouch?this.gestures.zoomLevels.correctZoomPan(!0):(// we run two animations instead of one,
// as each axis has own pan boundaries and thus different spring function
// (correctZoomPan does not have this functionality,
//  it animates all properties with single timing function)
this._finishPanGestureForAxis("x"),this._finishPanGestureForAxis("y"))}/**
   * @private
   * @param {'x' | 'y'} axis
   */_finishPanGestureForAxis(t){let{velocity:e}=this.gestures,{currSlide:i}=this.pswp;if(!i)return;let{pan:s,bounds:n}=i,o=s[t],a=this.pswp.bgOpacity<1&&"y"===t,r=o+.995*e[t]/(1-.995);if(a){let t=this._getVerticalDragRatio(o),e=this._getVerticalDragRatio(r);// or if we are below and moving downwards
if(t<0&&e<-.4||t>0&&e>.4){this.pswp.close();return}}// Pan position with corrected bounds
let h=n.correctPan(t,r);// Exit if pan position should not be changed
// or if speed it too low
if(o===h)return;// Overshoot if the final position is out of pan bounds
let l=h===r?1:.82,d=this.pswp.bgOpacity,p=h-o;this.pswp.animations.startSpring({name:"panGesture"+t,isPan:!0,start:o,end:h,velocity:e[t],dampingRatio:l,onUpdate:e=>{a&&this.pswp.bgOpacity<1&&// As progress ratio can be larger than 1 due to overshoot,
// and we do not want to bounce opacity.
this.pswp.applyBgOpacity(f(d+(1-d)*(1-(h-e)/p),0,1)),s[t]=Math.floor(e),i.applyCurrentZoomPan()}})}/**
   * Update position of the main scroll,
   * or/and update pan position of the current slide.
   *
   * Should return true if it changes (or can change) main scroll.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @returns {boolean}
   */_panOrMoveMainScroll(t){let{p1:e,dragAxis:i,prevP1:s,isMultitouch:n}=this.gestures,{currSlide:o,mainScroll:a}=this.pswp,r=e[t]-s[t],h=a.x+r;if(!r||!o)return!1;// Always move main scroll if image can not be panned
if("x"===t&&!o.isPannable()&&!n)return a.moveTo(h,!0),!0;// changed main scroll
let{bounds:l}=o,d=o.pan[t]+r;if(this.pswp.options.allowPanToNext&&"x"===i&&"x"===t&&!n){let e=a.getCurrSlideX(),i=a.x-e,s=r>0;// Position of the main scroll relative to the viewport
if(d>l.min[t]&&s){// Panning from left to right, beyond the left edge
// Wether the image was at minimum pan position (or less)
// when this drag gesture started.
// Minimum pan position refers to the left edge of the image.
let e=l.min[t]<=this.startPan[t];if(e)return a.moveTo(h,!0),!0;//currSlide.pan[axis] = newPan;
this._setPanWithFriction(t,d)}else if(d<l.max[t]&&!s){// Paning from right to left, beyond the right edge
// Maximum pan position refers to the right edge of the image.
let e=this.startPan[t]<=l.max[t];if(e)return a.moveTo(h,!0),!0;//currSlide.pan[axis] = newPan;
this._setPanWithFriction(t,d)}else if(0!==i){// If main scroll is shifted right
if(i>0)return a.moveTo(Math.max(h,e),!0),!0;if(i<0)return(// Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
a.moveTo(Math.min(h,e),!0),!0)}else this._setPanWithFriction(t,d)}else"y"===t&&(a.isShifted()||l.min.y===l.max.y)||this._setPanWithFriction(t,d);return!1}// If we move below the ratio is positive
/**
   * Relation between pan Y position and third of viewport height.
   *
   * When we are at initial position (center bounds) - the ratio is 0,
   * if position is shifted upwards - the ratio is negative,
   * if position is shifted downwards - the ratio is positive.
   *
   * @private
   * @param {number} panY The current pan Y position.
   * @returns {number}
   */_getVerticalDragRatio(t){var e,i;return(t-(null!==(e=null===(i=this.pswp.currSlide)||void 0===i?void 0:i.bounds.center.y)&&void 0!==e?e:0))/(this.pswp.viewportSize.y/3)}/**
   * Set pan position of the current slide.
   * Apply friction if the position is beyond the pan bounds,
   * or if custom friction is defined.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} potentialPan
   * @param {number} [customFriction] (0.1 - 1)
   */_setPanWithFriction(t,e,i){let{currSlide:s}=this.pswp;if(!s)return;let{pan:n,bounds:o}=s,a=o.correctPan(t,e);if(a!==e||i){let s=Math.round(e-n[t]);n[t]+=s*(i||.35)}else n[t]=e}/**
   * @param {Gestures} gestures
   */constructor(t){this.gestures=t,this.pswp=t.pswp,/** @type {Point} */this.startPan={x:0,y:0}}}/**
 * Get center point between two points
 *
 * @param {Point} p
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */function F(t,e,i){return t.x=(e.x+i.x)/2,t.y=(e.y+i.y)/2,t}class M{start(){let{currSlide:t}=this.gestures.pswp;t&&(this._startZoomLevel=t.currZoomLevel,v(this._startPan,t.pan)),this.gestures.pswp.animations.stopAllPan(),this._wasOverFitZoomLevel=!1}change(){let{p1:t,startP1:e,p2:i,startP2:s,pswp:n}=this.gestures,{currSlide:o}=n;if(!o)return;let a=o.zoomLevels.min,r=o.zoomLevels.max;if(!o.isZoomable()||n.mainScroll.isShifted())return;F(this._startZoomPoint,e,s),F(this._zoomPoint,t,i);let h=1/_(e,s)*_(t,i)*this._startZoomLevel;// slightly over the zoom.fit
if(h>o.zoomLevels.initial+o.zoomLevels.initial/15&&(this._wasOverFitZoomLevel=!0),h<a){if(n.options.pinchToClose&&!this._wasOverFitZoomLevel&&this._startZoomLevel<=o.zoomLevels.initial){// fade out background if zooming out
let t=1-(a-h)/(a/1.2);n.dispatch("pinchClose",{bgOpacity:t}).defaultPrevented||n.applyBgOpacity(t)}else h=a-(a-h)*.15}else h>r&&(h=r+(h-r)*.05);o.pan.x=this._calculatePanForZoomLevel("x",h),o.pan.y=this._calculatePanForZoomLevel("y",h),o.setZoomLevel(h),o.applyCurrentZoomPan()}end(){let{pswp:t}=this.gestures,{currSlide:e}=t;(!e||e.currZoomLevel<e.zoomLevels.initial)&&!this._wasOverFitZoomLevel&&t.options.pinchToClose?t.close():this.correctZoomPan()}/**
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} currZoomLevel
   * @returns {number}
   */_calculatePanForZoomLevel(t,e){let i=e/this._startZoomLevel;return this._zoomPoint[t]-(this._startZoomPoint[t]-this._startPan[t])*i}/**
   * Correct currZoomLevel and pan if they are
   * beyond minimum or maximum values.
   * With animation.
   *
   * @param {boolean} [ignoreGesture]
   * Wether gesture coordinates should be ignored when calculating destination pan position.
   */correctZoomPan(t){let e;let{pswp:i}=this.gestures,{currSlide:s}=i;if(!(null!=s&&s.isZoomable()))return;0===this._zoomPoint.x&&(t=!0);let n=s.currZoomLevel,o=!0;n<s.zoomLevels.initial?e=s.zoomLevels.initial:n>s.zoomLevels.max?e=s.zoomLevels.max:(o=!1,e=n);let a=i.bgOpacity,r=i.bgOpacity<1,h=v({x:0,y:0},s.pan),l=v({x:0,y:0},h);t&&(this._zoomPoint.x=0,this._zoomPoint.y=0,this._startZoomPoint.x=0,this._startZoomPoint.y=0,this._startZoomLevel=n,v(this._startPan,h)),o&&(l={x:this._calculatePanForZoomLevel("x",e),y:this._calculatePanForZoomLevel("y",e)}),// set zoom level, so pan bounds are updated according to it
s.setZoomLevel(e),l={x:s.bounds.correctPan("x",l.x),y:s.bounds.correctPan("y",l.y)},s.setZoomLevel(n);let d=!y(l,h);if(!d&&!o&&!r){// update resolution after gesture
s._setResolution(e),s.applyCurrentZoomPan();return}i.animations.stopAllPan(),i.animations.startSpring({isPan:!0,start:0,end:1e3,velocity:0,dampingRatio:1,naturalFrequency:40,onUpdate:t=>{if(t/=1e3,d||o){if(d&&(s.pan.x=h.x+(l.x-h.x)*t,s.pan.y=h.y+(l.y-h.y)*t),o){let i=n+(e-n)*t;s.setZoomLevel(i)}s.applyCurrentZoomPan()}// Restore background opacity
r&&i.bgOpacity<1&&// As progress ratio can be larger than 1 due to overshoot,
// and we do not want to bounce opacity.
i.applyBgOpacity(f(a+(1-a)*t,0,1))},onComplete:()=>{// update resolution after transition ends
s._setResolution(e),s.applyCurrentZoomPan()}})}/**
   * @param {Gestures} gestures
   */constructor(t){this.gestures=t,/**
     * @private
     * @type {Point}
     */this._startPan={x:0,y:0},/**
     * @private
     * @type {Point}
     */this._startZoomPoint={x:0,y:0},/**
     * @private
     * @type {Point}
     */this._zoomPoint={x:0,y:0},/** @private */this._wasOverFitZoomLevel=!1,/** @private */this._startZoomLevel=1}}/**
 * @template {string} T
 * @template {string} P
 * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
 *//** @typedef {import('./gestures.js').default} Gestures *//** @typedef {import('../photoswipe.js').Point} Point *//** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions *//**
 * Whether the tap was performed on the main slide
 * (rather than controls or caption).
 *
 * @param {PointerEvent} event
 * @returns {boolean}
 */function R(t){return!!/** @type {HTMLElement} */t.target.closest(".pswp__container")}/**
 * Tap, double-tap handler.
 */class k{/**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */click(t,e){let i=/** @type {HTMLElement} */e.target.classList,s=i.contains("pswp__img"),n=i.contains("pswp__item")||i.contains("pswp__zoom-wrap");s?this._doClickOrTapAction("imageClick",t,e):n&&this._doClickOrTapAction("bgClick",t,e)}/**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */tap(t,e){R(e)&&this._doClickOrTapAction("tap",t,e)}/**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */doubleTap(t,e){R(e)&&this._doClickOrTapAction("doubleTap",t,e)}/**
   * @private
   * @param {Actions} actionName
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */_doClickOrTapAction(t,e,i){var s;let{pswp:n}=this.gestures,{currSlide:o}=n,a=/** @type {AddPostfix<Actions, 'Action'>} */t+"Action",r=n.options[a];if(!n.dispatch(a,{point:e,originalEvent:i}).defaultPrevented){if("function"==typeof r){r.call(n,e,i);return}switch(r){case"close":case"next":n[r]();break;case"zoom":null==o||o.toggleZoom(e);break;case"zoom-or-close":// by default click zooms current image,
// if it can not be zoomed - gallery will be closed
null!=o&&o.isZoomable()&&o.zoomLevels.secondary!==o.zoomLevels.initial?o.toggleZoom(e):n.options.clickToCloseNonZoomable&&n.close();break;case"toggle-controls":null===(s=this.gestures.pswp.element)||void 0===s||s.classList.toggle("pswp--ui-visible");// if (_controlsVisible) {
}}}/**
   * @param {Gestures} gestures
   */constructor(t){this.gestures=t}}/**
 * Gestures class bind touch, pointer or mouse events
 * and emits drag to drag-handler and zoom events zoom-handler.
 *
 * Drag and zoom events are emited in requestAnimationFrame,
 * and only when one of pointers was actually changed.
 */class N{/**
   * @private
   * @param {'mouse' | 'touch' | 'pointer'} pref
   * @param {'down' | 'start'} down
   * @param {'up' | 'end'} up
   * @param {'cancel'} [cancel]
   */_bindEvents(t,e,i,s){let{pswp:n}=this,{events:o}=n,a=s?t+s:"";o.add(n.scrollWrap,t+e,/** @type EventListener */this.onPointerDown.bind(this)),o.add(window,t+"move",/** @type EventListener */this.onPointerMove.bind(this)),o.add(window,t+i,/** @type EventListener */this.onPointerUp.bind(this)),a&&o.add(n.scrollWrap,a,/** @type EventListener */this.onPointerUp.bind(this))}/**
   * @param {PointerEvent} e
   */onPointerDown(t){// We do not call preventDefault for touch events
// to allow browser to show native dialog on longpress
// (the one that allows to save image or open it in new tab).
//
// Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
// even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
let e="mousedown"===t.type||"mouse"===t.pointerType;// Allow dragging only via left mouse button.
// http://www.quirksmode.org/js/events_properties.html
// https://developer.mozilla.org/en-US/docs/Web/API/event.button
if(e&&t.button>0)return;let{pswp:i}=this;// if PhotoSwipe is opening or closing
if(!i.opener.isOpen){t.preventDefault();return}i.dispatch("pointerDown",{originalEvent:t}).defaultPrevented||(e&&(i.mouseDetected(),// browser image drag feature
this._preventPointerEventBehaviour(t)),i.animations.stopAll(),this._updatePoints(t,"down"),1===this._numActivePoints&&(this.dragAxis=null,// drag is activated only after the axis is determined
v(this.startP1,this.p1)),this._numActivePoints>1?(// Tap or double tap should not trigger if more than one pointer
this._clearTapTimer(),this.isMultitouch=!0):this.isMultitouch=!1)}/**
   * @param {PointerEvent} e
   */onPointerMove(t){t.preventDefault(),this._numActivePoints&&(this._updatePoints(t,"move"),this.pswp.dispatch("pointerMove",{originalEvent:t}).defaultPrevented||(1!==this._numActivePoints||this.isDragging?this._numActivePoints>1&&!this.isZooming&&(this._finishDrag(),this.isZooming=!0,this._updateStartPoints(),this.zoomLevels.start(),this._rafStopLoop(),this._rafRenderLoop()):(this.dragAxis||this._calculateDragDirection(),this.dragAxis&&!this.isDragging&&(this.isZooming&&(this.isZooming=!1,this.zoomLevels.end()),this.isDragging=!0,this._clearTapTimer(),// Adjust starting point
this._updateStartPoints(),this._intervalTime=Date.now(),this._velocityCalculated=!1,v(this._intervalP1,this.p1),this.velocity.x=0,this.velocity.y=0,this.drag.start(),this._rafStopLoop(),this._rafRenderLoop()))))}/**
   * @private
   */_finishDrag(){this.isDragging&&(this.isDragging=!1,this._velocityCalculated||this._updateVelocity(!0),this.drag.end(),this.dragAxis=null)}/**
   * @param {PointerEvent} e
   */onPointerUp(t){this._numActivePoints&&(this._updatePoints(t,"up"),!this.pswp.dispatch("pointerUp",{originalEvent:t}).defaultPrevented&&(0!==this._numActivePoints||(this._rafStopLoop(),this.isDragging?this._finishDrag():this.isZooming||this.isMultitouch||this._finishTap(t)),this._numActivePoints<2&&this.isZooming&&(this.isZooming=!1,this.zoomLevels.end(),1===this._numActivePoints&&(// Since we have 1 point left, we need to reinitiate drag
this.dragAxis=null,this._updateStartPoints()))))}/**
   * @private
   */_rafRenderLoop(){(this.isDragging||this.isZooming)&&(this._updateVelocity(),this.isDragging?y(this.p1,this.prevP1)||this.drag.change():y(this.p1,this.prevP1)&&y(this.p2,this.prevP2)||this.zoomLevels.change(),this._updatePrevPoints(),this.raf=requestAnimationFrame(this._rafRenderLoop.bind(this)))}/**
   * Update velocity at 50ms interval
   *
   * @private
   * @param {boolean} [force]
   */_updateVelocity(t){let e=Date.now(),i=e-this._intervalTime;(!(i<50)||t)&&(this.velocity.x=this._getVelocity("x",i),this.velocity.y=this._getVelocity("y",i),this._intervalTime=e,v(this._intervalP1,this.p1),this._velocityCalculated=!0)}/**
   * @private
   * @param {PointerEvent} e
   */_finishTap(t){let{mainScroll:e}=this.pswp;// Do not trigger tap events if main scroll is shifted
if(e.isShifted()){// restore main scroll position
// (usually happens if stopped in the middle of animation)
e.moveIndexBy(0,!0);return}// Do not trigger tap for touchcancel or pointercancel
if(t.type.indexOf("cancel")>0)return;// Trigger click instead of tap for mouse events
if("mouseup"===t.type||"mouse"===t.pointerType){this.tapHandler.click(this.startP1,t);return}// Disable delay if there is no doubleTapAction
let i=this.pswp.options.doubleTapAction?300:0;// If tapTimer is defined - we tapped recently,
// check if the current tap is close to the previous one,
// if yes - trigger double tap
this._tapTimer?(this._clearTapTimer(),25>_(this._lastStartP1,this.startP1)&&this.tapHandler.doubleTap(this.startP1,t)):(v(this._lastStartP1,this.startP1),this._tapTimer=setTimeout(()=>{this.tapHandler.tap(this.startP1,t),this._clearTapTimer()},i))}/**
   * @private
   */_clearTapTimer(){this._tapTimer&&(clearTimeout(this._tapTimer),this._tapTimer=null)}/**
   * Get velocity for axis
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} duration
   * @returns {number}
   */_getVelocity(t,e){// displacement is like distance, but can be negative.
let i=this.p1[t]-this._intervalP1[t];return Math.abs(i)>1&&e>5?i/e:0}/**
   * @private
   */_rafStopLoop(){this.raf&&(cancelAnimationFrame(this.raf),this.raf=null)}/**
   * @private
   * @param {PointerEvent} e
   */_preventPointerEventBehaviour(t){// TODO find a way to disable e.preventDefault on some elements
//      via event or some class or something
t.preventDefault()}/**
   * Parses and normalizes points from the touch, mouse or pointer event.
   * Updates p1 and p2.
   *
   * @private
   * @param {PointerEvent | TouchEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */_updatePoints(t,e){if(this._pointerEventEnabled){let i=this._ongoingPointers.findIndex(e=>e.id===/** @type {PointerEvent} */t.pointerId);"up"===e&&i>-1?this._ongoingPointers.splice(i,1):"down"===e&&-1===i?this._ongoingPointers.push(this._convertEventPosToPoint(t,{x:0,y:0})):i>-1&&this._convertEventPosToPoint(t,this._ongoingPointers[i]),this._numActivePoints=this._ongoingPointers.length,this._numActivePoints>0&&v(this.p1,this._ongoingPointers[0]),this._numActivePoints>1&&v(this.p2,this._ongoingPointers[1])}else this._numActivePoints=0,/** @type {TouchEvent} */t.type.indexOf("touch")>-1?t.touches&&t.touches.length>0&&(this._convertEventPosToPoint(t.touches[0],this.p1),this._numActivePoints++,t.touches.length>1&&(this._convertEventPosToPoint(t.touches[1],this.p2),this._numActivePoints++)):(// Mouse Event
this._convertEventPosToPoint(/** @type {PointerEvent} */t,this.p1),"up"===e?this._numActivePoints=0:this._numActivePoints++)}/** update points that were used during previous rAF tick
   * @private
   */_updatePrevPoints(){v(this.prevP1,this.p1),v(this.prevP2,this.p2)}/** update points at the start of gesture
   * @private
   */_updateStartPoints(){v(this.startP1,this.p1),v(this.startP2,this.p2),this._updatePrevPoints()}/** @private */_calculateDragDirection(){if(this.pswp.mainScroll.isShifted())this.dragAxis="x";else{// calculate delta of the last touchmove tick
let t=Math.abs(this.p1.x-this.startP1.x)-Math.abs(this.p1.y-this.startP1.y);if(0!==t){// check if pointer was shifted horizontally or vertically
let e=t>0?"x":"y";Math.abs(this.p1[e]-this.startP1[e])>=10&&(this.dragAxis=e)}}}/**
   * Converts touch, pointer or mouse event
   * to PhotoSwipe point.
   *
   * @private
   * @param {Touch | PointerEvent} e
   * @param {Point} p
   * @returns {Point}
   */_convertEventPosToPoint(t,e){return e.x=t.pageX-this.pswp.offset.x,e.y=t.pageY-this.pswp.offset.y,"pointerId"in t?e.id=t.pointerId:void 0!==t.identifier&&(e.id=t.identifier),e}/**
   * @private
   * @param {PointerEvent} e
   */_onClick(t){// Do not allow click event to pass through after drag
this.pswp.mainScroll.isShifted()&&(t.preventDefault(),t.stopPropagation())}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,/** @type {'x' | 'y' | null} */this.dragAxis=null,// PhotoSwipe keeps track only of two pointers, others are ignored
/** @type {Point} */this.p1={x:0,y:0},/** @type {Point} */this.p2={x:0,y:0},/** @type {Point} */this.prevP1={x:0,y:0},/** @type {Point} */this.prevP2={x:0,y:0},/** @type {Point} */this.startP1={x:0,y:0},/** @type {Point} */this.startP2={x:0,y:0},/** @type {Point} */this.velocity={x:0,y:0},/** @type {Point}
     * @private
     */this._lastStartP1={x:0,y:0},/** @type {Point}
     * @private
     */this._intervalP1={x:0,y:0},/** @private */this._numActivePoints=0,/** @type {Point[]}
     * @private
     */this._ongoingPointers=[],/** @private */this._touchEventEnabled="ontouchstart"in window,/** @private */this._pointerEventEnabled=!!window.PointerEvent,this.supportsTouch=this._touchEventEnabled||this._pointerEventEnabled&&navigator.maxTouchPoints>1,/** @private */this._numActivePoints=0,/** @private */this._intervalTime=0,/** @private */this._velocityCalculated=!1,this.isMultitouch=!1,this.isDragging=!1,this.isZooming=!1,/** @type {number | null} */this.raf=null,/** @type {NodeJS.Timeout | null}
     * @private
     */this._tapTimer=null,this.supportsTouch||(t.options.allowPanToNext=!1),this.drag=new Z(this),this.zoomLevels=new M(this),this.tapHandler=new k(this),t.on("bindEvents",()=>{t.events.add(t.scrollWrap,"click",/** @type EventListener */this._onClick.bind(this)),this._pointerEventEnabled?this._bindEvents("pointer","down","up","cancel"):this._touchEventEnabled?(this._bindEvents("touch","start","end","cancel"),t.scrollWrap&&(t.scrollWrap.ontouchmove=()=>{},t.scrollWrap.ontouchend=()=>{})):this._bindEvents("mouse","down","up")})}}// const MAX_SWIPE_TRABSITION_DURATION = 500;
// const DEFAULT_SWIPE_TRANSITION_DURATION = 333;
/**
 * Handles movement of the main scrolling container
 * (for example, it repositions when user swipes left or right).
 *
 * Also stores its state.
 */class B{/**
   * Position the scroller and slide containers
   * according to viewport size.
   *
   * @param {boolean} [resizeSlides] Whether slides content should resized
   */resize(t){let{pswp:e}=this,i=Math.round(e.viewportSize.x+e.viewportSize.x*e.options.spacing),s=i!==this.slideWidth;s&&(this.slideWidth=i,this.moveTo(this.getCurrSlideX())),this.itemHolders.forEach((e,i)=>{s&&S(e.el,(i+this._containerShiftIndex)*this.slideWidth),t&&e.slide&&e.slide.resize()})}/**
   * Reset X position of the main scroller to zero
   */resetPosition(){// Position on the main scroller (offset)
// it is independent from slide index
this._currPositionIndex=0,this._prevPositionIndex=0,this.slideWidth=0,this._containerShiftIndex=-1}/**
   * Create and append array of three items
   * that hold data about slides in DOM
   */appendHolders(){this.itemHolders=[];// append our three slide holders -
// previous, current, and next
for(let t=0;t<3;t++){let e=u("pswp__item","div",this.pswp.container);e.setAttribute("role","group"),e.setAttribute("aria-roledescription","slide"),e.setAttribute("aria-hidden","true"),e.style.display=1===t?"block":"none",this.itemHolders.push({el:e//index: -1
})}}/**
   * Whether the main scroll can be horizontally swiped to the next or previous slide.
   * @returns {boolean}
   */canBeSwiped(){return this.pswp.getNumItems()>1}/**
   * Move main scroll by X amount of slides.
   * For example:
   *   `-1` will move to the previous slide,
   *    `0` will reset the scroll position of the current slide,
   *    `3` will move three slides forward
   *
   * If loop option is enabled - index will be automatically looped too,
   * (for example `-1` will move to the last slide of the gallery).
   *
   * @param {number} diff
   * @param {boolean} [animate]
   * @param {number} [velocityX]
   * @returns {boolean} whether index was changed or not
   */moveIndexBy(t,e,i){let{pswp:s}=this,n=s.potentialIndex+t,o=s.getNumItems();if(s.canLoop()){n=s.getLoopedIndex(n);let e=(t+o)%o;t=e<=o/2?e:e-o}else n<0?n=0:n>=o&&(n=o-1),t=n-s.potentialIndex;s.potentialIndex=n,this._currPositionIndex-=t,s.animations.stopMainScroll();let a=this.getCurrSlideX();if(e){s.animations.startSpring({isMainScroll:!0,start:this.x,end:a,velocity:i||0,naturalFrequency:30,dampingRatio:1,//0.7,
onUpdate:t=>{this.moveTo(t)},onComplete:()=>{this.updateCurrItem(),s.appendHeavy()}});let t=s.potentialIndex-s.currIndex;if(s.canLoop()){let e=(t+o)%o;t=e<=o/2?e:e-o}// Force-append new slides during transition
// if difference between slides is more than 1
Math.abs(t)>1&&this.updateCurrItem()}else this.moveTo(a),this.updateCurrItem();return!!t}/**
   * X position of the main scroll for the current slide
   * (ignores position during dragging)
   * @returns {number}
   */getCurrSlideX(){return this.slideWidth*this._currPositionIndex}/**
   * Whether scroll position is shifted.
   * For example, it will return true if the scroll is being dragged or animated.
   * @returns {boolean}
   */isShifted(){return this.x!==this.getCurrSlideX()}/**
   * Update slides X positions and set their content
   */updateCurrItem(){var t;let e;let{pswp:i}=this,s=this._prevPositionIndex-this._currPositionIndex;if(!s)return;this._prevPositionIndex=this._currPositionIndex,i.currIndex=i.potentialIndex;let n=Math.abs(s);n>=3&&(this._containerShiftIndex+=s+(s>0?-3:3),n=3);for(let t=0;t<n;t++)s>0?(e=this.itemHolders.shift())&&(this.itemHolders[2]=e,this._containerShiftIndex++,S(e.el,(this._containerShiftIndex+2)*this.slideWidth),i.setContent(e,i.currIndex-n+t+2)):(e=this.itemHolders.pop())&&(this.itemHolders.unshift(e),this._containerShiftIndex--,S(e.el,this._containerShiftIndex*this.slideWidth),i.setContent(e,i.currIndex+n-t-2));Math.abs(this._containerShiftIndex)>50&&!this.isShifted()&&(this.resetPosition(),this.resize()),i.animations.stopAllPan(),this.itemHolders.forEach((t,e)=>{t.slide&&t.slide.setIsActive(1===e)}),i.currSlide=null===(t=this.itemHolders[1])||void 0===t?void 0:t.slide,i.contentLoader.updateLazy(s),i.currSlide&&i.currSlide.applyCurrentZoomPan(),i.dispatch("change")}/**
   * Move the X position of the main scroll container
   *
   * @param {number} x
   * @param {boolean} [dragging]
   */moveTo(t,e){if(!this.pswp.canLoop()&&e){// Apply friction
let e=(this.slideWidth*this._currPositionIndex-t)/this.slideWidth;e+=this.pswp.currIndex;let i=Math.round(t-this.x);(e<0&&i>0||e>=this.pswp.getNumItems()-1&&i<0)&&(t=this.x+.35*i)}this.x=t,this.pswp.container&&S(this.pswp.container,t),this.pswp.dispatch("moveMainScroll",{x:t,dragging:null!=e&&e})}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,this.x=0,this.slideWidth=0,/** @private */this._currPositionIndex=0,/** @private */this._prevPositionIndex=0,/** @private */this._containerShiftIndex=-1,/** @type {ItemHolder[]} */this.itemHolders=[]}}/** @typedef {import('./photoswipe.js').default} PhotoSwipe *//**
 * @template T
 * @typedef {import('./types.js').Methods<T>} Methods<T>
 */let H={Escape:27,z:90,ArrowLeft:37,ArrowUp:38,ArrowRight:39,ArrowDown:40,Tab:9},W=(t,e)=>e?t:H[t];/**
 * - Manages keyboard shortcuts.
 * - Helps trap focus within photoswipe.
 */class q{/** @private */_focusRoot(){!this._wasFocused&&this.pswp.element&&(this.pswp.element.focus(),this._wasFocused=!0)}/**
   * @private
   * @param {KeyboardEvent} e
   */_onKeyDown(t){let e,i;let{pswp:s}=this;if(s.dispatch("keydown",{originalEvent:t}).defaultPrevented||"button"in t&&1===t.button||t.ctrlKey||t.metaKey||t.altKey||t.shiftKey)return;let n=!1,o="key"in t;switch(o?t.key:t.keyCode){case W("Escape",o):s.options.escKey&&(e="close");break;case W("z",o):e="toggleZoom";break;case W("ArrowLeft",o):i="x";break;case W("ArrowUp",o):i="y";break;case W("ArrowRight",o):i="x",n=!0;break;case W("ArrowDown",o):n=!0,i="y";break;case W("Tab",o):this._focusRoot()}// if left/right/top/bottom key
if(i){// prevent page scroll
t.preventDefault();let{currSlide:o}=s;s.options.arrowKeys&&"x"===i&&s.getNumItems()>1?e=n?"next":"prev":o&&o.currZoomLevel>o.zoomLevels.fit&&(// up/down arrow keys pan the image vertically
// left/right arrow keys pan horizontally.
// Unless there is only one image,
// or arrowKeys option is disabled
o.pan[i]+=n?-80:80,o.panTo(o.pan.x,o.pan.y))}e&&(t.preventDefault(),s[e]())}/**
   * Trap focus inside photoswipe
   *
   * @private
   * @param {FocusEvent} e
   */_onFocusIn(t){let{template:e}=this.pswp;e&&document!==t.target&&e!==t.target&&!e.contains(/** @type {Node} */t.target)&&e.focus()}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,/** @private */this._wasFocused=!1,t.on("bindEvents",()=>{t.options.initialPointerPos||// which causes lag during the animation,
// that's why we delay it until the opener transition ends
this._focusRoot(),t.events.add(document,"focusin",/** @type EventListener */this._onFocusIn.bind(this)),t.events.add(document,"keydown",/** @type EventListener */this._onKeyDown.bind(this))});let e=/** @type {HTMLElement} */document.activeElement;t.on("destroy",()=>{t.options.returnFocus&&e&&this._wasFocused&&e.focus()})}}/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps *//** @typedef {Object} DefaultCssAnimationProps
 *
 * @prop {HTMLElement} target
 * @prop {number} [duration]
 * @prop {string} [easing]
 * @prop {string} [transform]
 * @prop {string} [opacity]
 * *//** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps *//**
 * Runs CSS transition.
 */class V{/**
   * @private
   * @param {TransitionEvent} e
   */_onTransitionEnd(t){t.target===this._target&&this._finalizeAnimation()}/**
   * @private
   */_finalizeAnimation(){!this._finished&&(this._finished=!0,this.onFinish(),this._onComplete&&this._onComplete())}destroy(){this._helperTimeout&&clearTimeout(this._helperTimeout),x(this._target),this._target.removeEventListener("transitionend",this._onTransitionEnd,!1),this._target.removeEventListener("transitioncancel",this._onTransitionEnd,!1),this._finished||this._finalizeAnimation()}/**
   * onComplete can be unpredictable, be careful about current state
   *
   * @param {CssAnimationProps} props
   */constructor(t){var e;this.props=t;let{target:i,onComplete:s,transform:n,onFinish:o=()=>{},duration:a=333,easing:r="cubic-bezier(.4,0,.22,1)"}=t;this.onFinish=o;let h=n?"transform":"opacity",l=null!==(e=t[h])&&void 0!==e?e:"";/** @private */this._target=i,/** @private */this._onComplete=s,/** @private */this._finished=!1,/** @private */this._onTransitionEnd=this._onTransitionEnd.bind(this),// starts even if the animated property was changed recently,
// otherwise transitionend might not fire or transition won't start.
// https://drafts.csswg.org/css-transitions/#starting
//
// ¯\_(ツ)_/¯
/** @private */this._helperTimeout=setTimeout(()=>{x(i,h,a,r),this._helperTimeout=setTimeout(()=>{i.addEventListener("transitionend",this._onTransitionEnd,!1),i.addEventListener("transitioncancel",this._onTransitionEnd,!1),// if element property was modified during the transition,
// which may be caused by resize or third party component,
// using timeout as a safety fallback
this._helperTimeout=setTimeout(()=>{this._finalizeAnimation()},a+500),i.style[h]=l},30)},0)}}/**
 * Spring easing helper
 */class G{/**
   * @param {number} deltaPosition Difference between current and end position of the animation
   * @param {number} deltaTime Frame duration in milliseconds
   *
   * @returns {number} Displacement, relative to the end position.
   */easeFrame(t,e){// Inspired by Apple Webkit and Android spring function implementation
// https://en.wikipedia.org/wiki/Oscillation
// https://en.wikipedia.org/wiki/Damping_ratio
// we ignore mass (assume that it's 1kg)
let i,s=0;e/=1e3;let n=Math.E**(-this._dampingRatio*this._naturalFrequency*e);if(1===this._dampingRatio)i=this.velocity+this._naturalFrequency*t,s=(t+i*e)*n,this.velocity=-(s*this._naturalFrequency)+i*n;else if(this._dampingRatio<1){i=1/this._dampedFrequency*(this._dampingRatio*this._naturalFrequency*t+this.velocity);let o=Math.cos(this._dampedFrequency*e),a=Math.sin(this._dampedFrequency*e);s=n*(t*o+i*a),this.velocity=-(s*this._naturalFrequency)*this._dampingRatio+n*(-this._dampedFrequency*t*a+this._dampedFrequency*i*o)}// Overdamped (>1) damping ratio is not supported
return s}/**
   * @param {number} initialVelocity Initial velocity, px per ms.
   *
   * @param {number} [dampingRatio]
   * Determines how bouncy animation will be.
   * From 0 to 1, 0 - always overshoot, 1 - do not overshoot.
   * "overshoot" refers to part of animation that
   * goes beyond the final value.
   *
   * @param {number} [naturalFrequency]
   * Determines how fast animation will slow down.
   * The higher value - the stiffer the transition will be,
   * and the faster it will slow down.
   * Recommended value from 10 to 50
   */constructor(t,e,i){this.velocity=1e3*t,// https://en.wikipedia.org/wiki/Damping_ratio
this._dampingRatio=e||.75,this._naturalFrequency=i||12,this._dampedFrequency=this._naturalFrequency,this._dampingRatio<1&&(this._dampedFrequency*=Math.sqrt(1-this._dampingRatio*this._dampingRatio))}}/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps *//**
 * @typedef {Object} DefaultSpringAnimationProps
 *
 * @prop {number} start
 * @prop {number} end
 * @prop {number} velocity
 * @prop {number} [dampingRatio]
 * @prop {number} [naturalFrequency]
 * @prop {(end: number) => void} onUpdate
 *//** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */class U{destroy(){this._raf>=0&&cancelAnimationFrame(this._raf),this._raf=0}/**
   * @param {SpringAnimationProps} props
   */constructor(t){this.props=t,this._raf=0;let{start:e,end:i,velocity:s,onUpdate:n,onComplete:o,onFinish:a=()=>{},dampingRatio:r,naturalFrequency:h}=t;this.onFinish=a;let l=new G(s,r,h),d=Date.now(),p=e-i,c=()=>{this._raf&&(1>Math.abs(p=l.easeFrame(p,Date.now()-d))&&50>Math.abs(l.velocity)?(// Finalize the animation
n(i),o&&o(),this.onFinish()):(d=Date.now(),n(p+i),this._raf=requestAnimationFrame(c)))};this._raf=requestAnimationFrame(c)}}/** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps *//** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps *//** @typedef {Object} SharedAnimationProps
 * @prop {string} [name]
 * @prop {boolean} [isPan]
 * @prop {boolean} [isMainScroll]
 * @prop {VoidFunction} [onComplete]
 * @prop {VoidFunction} [onFinish]
 *//** @typedef {SpringAnimation | CSSAnimation} Animation *//** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps *//**
 * Manages animations
 */class j{/**
   * @param {SpringAnimationProps} props
   */startSpring(t){this._start(t,!0)}/**
   * @param {CssAnimationProps} props
   */startTransition(t){this._start(t)}/**
   * @private
   * @param {AnimationProps} props
   * @param {boolean} [isSpring]
   * @returns {Animation}
   */_start(t,e){let i=e?new U(/** @type SpringAnimationProps */t):new V(/** @type CssAnimationProps */t);return this.activeAnimations.push(i),i.onFinish=()=>this.stop(i),i}/**
   * @param {Animation} animation
   */stop(t){t.destroy();let e=this.activeAnimations.indexOf(t);e>-1&&this.activeAnimations.splice(e,1)}stopAll(){// _stopAllAnimations
this.activeAnimations.forEach(t=>{t.destroy()}),this.activeAnimations=[]}/**
   * Stop all pan or zoom transitions
   */stopAllPan(){this.activeAnimations=this.activeAnimations.filter(t=>!t.props.isPan||(t.destroy(),!1))}stopMainScroll(){this.activeAnimations=this.activeAnimations.filter(t=>!t.props.isMainScroll||(t.destroy(),!1))}/**
   * Returns true if main scroll transition is running
   */// isMainScrollRunning() {
//   return this.activeAnimations.some((animation) => {
//     return animation.props.isMainScroll;
//   });
// }
/**
   * Returns true if any pan or zoom transition is running
   */isPanRunning(){return this.activeAnimations.some(t=>t.props.isPan)}constructor(){/** @type {Animation[]} */this.activeAnimations=[]}}/** @typedef {import('./photoswipe.js').default} PhotoSwipe *//**
 * Handles scroll wheel.
 * Can pan and zoom current slide image.
 */class K{/**
   * @private
   * @param {WheelEvent} e
   */_onWheel(t){t.preventDefault();let{currSlide:e}=this.pswp,{deltaX:i,deltaY:s}=t;if(e&&!this.pswp.dispatch("wheel",{originalEvent:t}).defaultPrevented){if(t.ctrlKey||this.pswp.options.wheelToZoom){if(e.isZoomable()){let i=-s;1===t.deltaMode?i*=.05:i*=t.deltaMode?1:.002,i=2**i;let n=e.currZoomLevel*i;e.zoomTo(n,{x:t.clientX,y:t.clientY})}}else e.isPannable()&&(1===t.deltaMode&&(// 18 - average line height
i*=18,s*=18),e.panTo(e.pan.x-i,e.pan.y-s))}}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,t.events.add(t.element,"wheel",/** @type EventListener */this._onWheel.bind(this))}}class X{/**
   * @param {PhotoSwipe} pswp
   * @param {UIElementData} data
   */constructor(t,e){var i;let s=e.name||e.className,n=e.html;if(!1===t.options[s])return;"string"==typeof t.options[s+"SVG"]&&// arrowNextSVG
// closeSVG
// zoomSVG
// @ts-expect-error lookup only by `data.name` maybe?
(n=t.options[s+"SVG"]),t.dispatch("uiElementCreate",{data:e});let o="";e.isButton?o+="pswp__button "+(e.className||`pswp__button--${e.name}`):o+=e.className||`pswp__${e.name}`;let a=e.isButton?e.tagName||"button":e.tagName||"div";a=/** @type {keyof HTMLElementTagNameMap} */a.toLowerCase();/** @type {HTMLElement} */let r=u(o,a);if(e.isButton){"button"===a&&/** @type {HTMLButtonElement} */(r.type="button");let{title:i}=e,{ariaLabel:n}=e;"string"==typeof t.options[s+"Title"]&&(i=t.options[s+"Title"]),i&&(r.title=i);let o=n||i;o&&r.setAttribute("aria-label",o)}r.innerHTML=/** @typedef {import('../photoswipe.js').default} PhotoSwipe *//**
 * @template T
 * @typedef {import('../types.js').Methods<T>} Methods<T>
 *//**
 * @typedef {Object} UIElementMarkupProps
 * @prop {boolean} [isCustomSVG]
 * @prop {string} inner
 * @prop {string} [outlineID]
 * @prop {number | string} [size]
 *//**
 * @typedef {Object} UIElementData
 * @prop {DefaultUIElements | string} [name]
 * @prop {string} [className]
 * @prop {UIElementMarkup} [html]
 * @prop {boolean} [isButton]
 * @prop {keyof HTMLElementTagNameMap} [tagName]
 * @prop {string} [title]
 * @prop {string} [ariaLabel]
 * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
 * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
 * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
 * @prop {number} [order]
 *//** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements *//** @typedef {string | UIElementMarkupProps} UIElementMarkup *//**
 * @param {UIElementMarkup} [htmlData]
 * @returns {string}
 */function(t){if("string"==typeof t)// For example:
// <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
//   <path d="..." />
//   <circle ... />
// </svg>
// Can also be any HTML string.
return t;if(!t||!t.isCustomSVG)return"";let e='<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';// replace all %d with size
return e=e.split("%d").join(/** @type {string} */t.size||32),t.outlineID&&(e+='<use class="pswp__icn-shadow" xlink:href="#'+t.outlineID+'"/>'),e+=t.inner+"</svg>"}(n),e.onInit&&e.onInit(r,t),e.onClick&&(r.onclick=i=>{"string"==typeof e.onClick?t[e.onClick]():"function"==typeof e.onClick&&e.onClick(i,r,t)});// Top bar is default position
let h=e.appendTo||"bar",l=t.element;"bar"===h?(t.topBar||(t.topBar=u("pswp__top-bar pswp__hide-on-close","div",t.scrollWrap)),l=t.topBar):(// element outside of top bar gets a secondary class
// that makes element fade out on close
r.classList.add("pswp__hide-on-close"),"wrapper"===h&&(l=t.scrollWrap)),null===(i=l)||void 0===i||i.appendChild(t.applyFilters("uiElement",r,e))}}/*
  Backward and forward arrow buttons
 *//** @typedef {import('./ui-element.js').UIElementData} UIElementData *//** @typedef {import('../photoswipe.js').default} PhotoSwipe *//**
 *
 * @param {HTMLElement} element
 * @param {PhotoSwipe} pswp
 * @param {boolean} [isNextButton]
 */function Y(t,e,i){t.classList.add("pswp__button--arrow"),t.setAttribute("aria-controls","pswp__items"),e.on("change",()=>{e.options.loop||(i?/** @type {HTMLButtonElement} */t.disabled=!(e.currIndex<e.getNumItems()-1):/** @type {HTMLButtonElement} */t.disabled=!(e.currIndex>0))})}/** @type {UIElementData} */let Q={name:"arrowPrev",className:"pswp__button--arrow--prev",title:"Previous",order:10,isButton:!0,appendTo:"wrapper",html:{isCustomSVG:!0,size:60,inner:'<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',outlineID:"pswp__icn-arrow"},onClick:"prev",onInit:Y},J={name:"arrowNext",className:"pswp__button--arrow--next",title:"Next",order:11,isButton:!0,appendTo:"wrapper",html:{isCustomSVG:!0,size:60,inner:'<use xlink:href="#pswp__icn-arrow"/>',outlineID:"pswp__icn-arrow"},onClick:"next",onInit:(t,e)=>{Y(t,e,!0)}},tt={name:"close",title:"Close",order:20,isButton:!0,html:{isCustomSVG:!0,inner:'<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',outlineID:"pswp__icn-close"},onClick:"close"},te={name:"zoom",title:"Zoom",order:10,isButton:!0,html:{isCustomSVG:!0,// eslint-disable-next-line max-len
inner:'<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',outlineID:"pswp__icn-zoom"},onClick:"toggleZoom"},ti={name:"preloader",appendTo:"bar",order:7,html:{isCustomSVG:!0,// eslint-disable-next-line max-len
inner:'<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',outlineID:"pswp__icn-loading"},onInit:(t,e)=>{let i;/** @type {NodeJS.Timeout | null} */let s=null,n=(e,i)=>{t.classList.toggle("pswp__preloader--"+e,i)},o=t=>{i!==t&&(i=t,n("active",t))},a=()=>{var t;if(!(null!==(t=e.currSlide)&&void 0!==t&&t.content.isLoading())){o(!1),s&&(clearTimeout(s),s=null);return}s||(s=setTimeout(()=>{var t;o(!!(null===(t=e.currSlide)||void 0===t?void 0:t.content.isLoading())),s=null},e.options.preloaderDelay))};e.on("change",a),e.on("loadComplete",t=>{e.currSlide===t.slide&&a()}),e.ui&&(e.ui.updatePreloaderVisibility=a)}},ts={name:"counter",order:5,onInit:(t,e)=>{e.on("change",()=>{t.innerText=e.currIndex+1+e.options.indexIndicatorSep+e.getNumItems()})}};/** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('./ui-element.js').UIElementData} UIElementData *//**
 * Set special class on element when image is zoomed.
 *
 * By default, it is used to adjust
 * zoom icon and zoom cursor via CSS.
 *
 * @param {HTMLElement} el
 * @param {boolean} isZoomedIn
 */function tn(t,e){t.classList.toggle("pswp--zoomed-in",e)}class to{init(){let{pswp:t}=this;this.isRegistered=!1,this.uiElementsData=[tt,Q,J,te,ti,ts],t.dispatch("uiRegister"),this.uiElementsData.sort((t,e)=>(t.order||0)-(e.order||0)),this.items=[],this.isRegistered=!0,this.uiElementsData.forEach(t=>{this.registerElement(t)}),t.on("change",()=>{var e;null===(e=t.element)||void 0===e||e.classList.toggle("pswp--one-slide",1===t.getNumItems())}),t.on("zoomPanUpdate",()=>this._onZoomPanUpdate())}/**
   * @param {UIElementData} elementData
   */registerElement(t){this.isRegistered?this.items.push(new X(this.pswp,t)):this.uiElementsData.push(t)}/**
   * Fired each time zoom or pan position is changed.
   * Update classes that control visibility of zoom button and cursor icon.
   *
   * @private
   */_onZoomPanUpdate(){let{template:t,currSlide:e,options:i}=this.pswp;if(this.pswp.opener.isClosing||!t||!e)return;let{currZoomLevel:s}=e;// if not open yet - check against initial zoom level
if(this.pswp.opener.isOpen||(s=e.zoomLevels.initial),s===this._lastUpdatedZoomLevel)return;this._lastUpdatedZoomLevel=s;let n=e.zoomLevels.initial-e.zoomLevels.secondary;// Initial and secondary zoom levels are almost equal
if(.01>Math.abs(n)||!e.isZoomable()){// disable zoom
tn(t,!1),t.classList.remove("pswp--zoom-allowed");return}t.classList.add("pswp--zoom-allowed");let o=s===e.zoomLevels.initial?e.zoomLevels.secondary:e.zoomLevels.initial;tn(t,o<=s),("zoom"===i.imageClickAction||"zoom-or-close"===i.imageClickAction)&&t.classList.add("pswp--click-to-zoom")}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,this.isRegistered=!1,/** @type {UIElementData[]} */this.uiElementsData=[],/** @type {(UIElement | UIElementData)[]} */this.items=[],/** @type {() => void} */this.updatePreloaderVisibility=()=>{},/**
     * @private
     * @type {number | undefined}
     */this._lastUpdatedZoomLevel=void 0}}/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox *//** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions *//** @typedef {import('../photoswipe.js').DataSource} DataSource *//** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData *//** @typedef {import('../slide/content.js').default} ContentDefault *//** @typedef {import('../slide/slide.js').default} Slide *//** @typedef {import('../slide/slide.js').SlideData} SlideData *//** @typedef {import('../slide/zoom-level.js').default} ZoomLevel *//** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds *//**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 *//** @typedef {{ x?: number; y?: number }} Point *//**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 *//**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thubmnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thubmnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 *//**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 *//**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */class ta{preventDefault(){this.defaultPrevented=!0}/**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */constructor(t,e){this.type=t,this.defaultPrevented=!1,e&&Object.assign(this,e)}}/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */class tr{/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */addFilter(t,e,i=100){var s,n,o;this._filters[t]||(this._filters[t]=[]),null===(s=this._filters[t])||void 0===s||s.push({fn:e,priority:i}),null===(n=this._filters[t])||void 0===n||n.sort((t,e)=>t.priority-e.priority),null===(o=this.pswp)||void 0===o||o.addFilter(t,e,i)}/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */removeFilter(t,e){this._filters[t]&&(this._filters[t]=this._filters[t].filter(t=>t.fn!==e)),this.pswp&&this.pswp.removeFilter(t,e)}/**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */applyFilters(t,...e){var i;return null===(i=this._filters[t])||void 0===i||i.forEach(t=>{// @ts-expect-error
e[0]=t.fn.apply(this,e)}),e[0]}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */on(t,e){var i,s;this._listeners[t]||(this._listeners[t]=[]),null===(i=this._listeners[t])||void 0===i||i.push(e),null===// also bind events to PhotoSwipe Core,
// if it's open.
(s=this.pswp)||void 0===s||s.on(t,e)}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */off(t,e){var i;this._listeners[t]&&(this._listeners[t]=this._listeners[t].filter(t=>e!==t)),null===(i=this.pswp)||void 0===i||i.off(t,e)}/**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */dispatch(t,e){var i;if(this.pswp)return this.pswp.dispatch(t,e);let s=/** @type {AugmentedEvent<T>} */new ta(t,e);return null===(i=this._listeners[t])||void 0===i||i.forEach(t=>{t.call(this,s)}),s}constructor(){/**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */this._listeners={},/**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */this._filters={},/** @type {PhotoSwipe | undefined} */this.pswp=void 0,/** @type {PhotoSwipeOptions | undefined} */this.options=void 0}}class th{/**
   * @param {number} width
   * @param {number} height
   */setDisplayedSize(t,e){this.element&&("IMG"===this.element.tagName?(// Use transform scale() to modify img placeholder size
// (instead of changing width/height directly).
// This helps with performance, specifically in iOS15 Safari.
P(this.element,250,"auto"),this.element.style.transformOrigin="0 0",this.element.style.transform=w(0,0,t/250)):P(this.element,t,e))}destroy(){var t;null!==(t=this.element)&&void 0!==t&&t.parentNode&&this.element.remove(),this.element=null}/**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */constructor(t,e){if(// Create placeholder
// (stretched thumbnail or simple div behind the main image)
/** @type {HTMLImageElement | HTMLDivElement | null} */this.element=u("pswp__img pswp__img--placeholder",t?"img":"div",e),t){let e=/** @type {HTMLImageElement} */this.element;e.decoding="async",e.alt="",e.src=t,e.setAttribute("role","presentation")}this.element.setAttribute("aria-hidden","true")}}/** @typedef {import('./slide.js').default} Slide *//** @typedef {import('./slide.js').SlideData} SlideData *//** @typedef {import('../core/base.js').default} PhotoSwipeBase *//** @typedef {import('../util/util.js').LoadState} LoadState */class tl{removePlaceholder(){this.placeholder&&!this.keepPlaceholder()&&setTimeout(()=>{this.placeholder&&(this.placeholder.destroy(),this.placeholder=void 0)},1e3)}/**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */load(t,e){if(this.slide&&this.usePlaceholder()){if(this.placeholder){let t=this.placeholder.element;// Add placeholder to DOM if it was already created
t&&!t.parentElement&&this.slide.container.prepend(t)}else{let t=this.instance.applyFilters("placeholderSrc",!!this.data.msrc&&!!this.slide.isFirstSlide&&this.data.msrc,this);this.placeholder=new th(t,this.slide.container)}}(!this.element||e)&&!this.instance.dispatch("contentLoad",{content:this,isLazy:t}).defaultPrevented&&(this.isImageContent()?(this.element=u("pswp__img","img"),this.displayedImageWidth&&this.loadImage(t)):(this.element=u("pswp__content","div"),this.element.innerHTML=this.data.html||""),e&&this.slide&&this.slide.updateContentSize(!0))}/**
   * Preload image
   *
   * @param {boolean} isLazy
   */loadImage(t){var e,i;if(!this.isImageContent()||!this.element||this.instance.dispatch("contentLoadImage",{content:this,isLazy:t}).defaultPrevented)return;let s=/** @type HTMLImageElement */this.element;this.updateSrcsetSizes(),this.data.srcset&&(s.srcset=this.data.srcset),s.src=null!==(e=this.data.src)&&void 0!==e?e:"",s.alt=null!==(i=this.data.alt)&&void 0!==i?i:"",this.state=b.LOADING,s.complete?this.onLoaded():(s.onload=()=>{this.onLoaded()},s.onerror=()=>{this.onError()})}/**
   * Assign slide to content
   *
   * @param {Slide} slide
   */setSlide(t){this.slide=t,this.hasSlide=!0,this.instance=t.pswp}/**
   * Content load success handler
   */onLoaded(){this.state=b.LOADED,this.slide&&this.element&&(this.instance.dispatch("loadComplete",{slide:this.slide,content:this}),this.slide.isActive&&this.slide.heavyAppended&&!this.element.parentNode&&(this.append(),this.slide.updateContentSize(!0)),(this.state===b.LOADED||this.state===b.ERROR)&&this.removePlaceholder())}/**
   * Content load error handler
   */onError(){this.state=b.ERROR,this.slide&&(this.displayError(),this.instance.dispatch("loadComplete",{slide:this.slide,isError:!0,content:this}),this.instance.dispatch("loadError",{slide:this.slide,content:this}))}/**
   * @returns {Boolean} If the content is currently loading
   */isLoading(){return this.instance.applyFilters("isContentLoading",this.state===b.LOADING,this)}/**
   * @returns {Boolean} If the content is in error state
   */isError(){return this.state===b.ERROR}/**
   * @returns {boolean} If the content is image
   */isImageContent(){return"image"===this.type}/**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */setDisplayedSize(t,e){if(this.element&&(this.placeholder&&this.placeholder.setDisplayedSize(t,e),!this.instance.dispatch("contentResize",{content:this,width:t,height:e}).defaultPrevented&&(P(this.element,t,e),this.isImageContent()&&!this.isError()))){let i=!this.displayedImageWidth&&t;this.displayedImageWidth=t,this.displayedImageHeight=e,i?this.loadImage(!1):this.updateSrcsetSizes(),this.slide&&this.instance.dispatch("imageSizeChange",{slide:this.slide,width:t,height:e,content:this})}}/**
   * @returns {boolean} If the content can be zoomed
   */isZoomable(){return this.instance.applyFilters("isContentZoomable",this.isImageContent()&&this.state!==b.ERROR,this)}/**
   * Update image srcset sizes attribute based on width and height
   */updateSrcsetSizes(){// Handle srcset sizes attribute.
//
// Never lower quality, if it was increased previously.
// Chrome does this automatically, Firefox and Safari do not,
// so we store largest used size in dataset.
if(!this.isImageContent()||!this.element||!this.data.srcset)return;let t=/** @type HTMLImageElement */this.element,e=this.instance.applyFilters("srcsetSizesWidth",this.displayedImageWidth,this);(!t.dataset.largestUsedSize||e>parseInt(t.dataset.largestUsedSize,10))&&(t.sizes=e+"px",t.dataset.largestUsedSize=String(e))}/**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */usePlaceholder(){return this.instance.applyFilters("useContentPlaceholder",this.isImageContent(),this)}/**
   * Preload content with lazy-loading param
   */lazyLoad(){this.instance.dispatch("contentLazyLoad",{content:this}).defaultPrevented||this.load(!0)}/**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */keepPlaceholder(){return this.instance.applyFilters("isKeepingPlaceholder",this.isLoading(),this)}/**
   * Destroy the content
   */destroy(){this.hasSlide=!1,this.slide=void 0,!this.instance.dispatch("contentDestroy",{content:this}).defaultPrevented&&(this.remove(),this.placeholder&&(this.placeholder.destroy(),this.placeholder=void 0),this.isImageContent()&&this.element&&(this.element.onload=null,this.element.onerror=null,this.element=void 0))}/**
   * Display error message
   */displayError(){if(this.slide){var t,e;let i=u("pswp__error-msg","div");i.innerText=null!==(t=null===(e=this.instance.options)||void 0===e?void 0:e.errorMsg)&&void 0!==t?t:"",i=/** @type {HTMLDivElement} */this.instance.applyFilters("contentErrorElement",i,this),this.element=u("pswp__content pswp__error-msg-container","div"),this.element.appendChild(i),this.slide.container.innerText="",this.slide.container.appendChild(this.element),this.slide.updateContentSize(!0),this.removePlaceholder()}}/**
   * Append the content
   */append(){if(this.isAttached||!this.element)return;if(this.isAttached=!0,this.state===b.ERROR){this.displayError();return}if(this.instance.dispatch("contentAppend",{content:this}).defaultPrevented)return;let t="decode"in this.element;this.isImageContent()?t&&this.slide&&(!this.slide.isActive||C())?(this.isDecoding=!0,// as if srcset sizes changes dynamically - it may cause decode error
/** @type {HTMLImageElement} */this.element.decode().catch(()=>{}).finally(()=>{this.isDecoding=!1,this.appendImage()})):this.appendImage():this.slide&&!this.element.parentNode&&this.slide.container.appendChild(this.element)}/**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */activate(){!this.instance.dispatch("contentActivate",{content:this}).defaultPrevented&&this.slide&&(this.isImageContent()&&this.isDecoding&&!C()?// even if it's not finished decoding
this.appendImage():this.isError()&&this.load(!1,!0),this.slide.holderElement&&this.slide.holderElement.setAttribute("aria-hidden","false"))}/**
   * Deactivate the content
   */deactivate(){this.instance.dispatch("contentDeactivate",{content:this}),this.slide&&this.slide.holderElement&&this.slide.holderElement.setAttribute("aria-hidden","true")}/**
   * Remove the content from DOM
   */remove(){this.isAttached=!1,!this.instance.dispatch("contentRemove",{content:this}).defaultPrevented&&(this.element&&this.element.parentNode&&this.element.remove(),this.placeholder&&this.placeholder.element&&this.placeholder.element.remove())}/**
   * Append the image content to slide container
   */appendImage(){this.isAttached&&(this.instance.dispatch("contentAppendImage",{content:this}).defaultPrevented||(this.slide&&this.element&&!this.element.parentNode&&this.slide.container.appendChild(this.element),(this.state===b.LOADED||this.state===b.ERROR)&&this.removePlaceholder()))}/**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */constructor(t,e,i){this.instance=e,this.data=t,this.index=i,/** @type {HTMLImageElement | HTMLDivElement | undefined} */this.element=void 0,/** @type {Placeholder | undefined} */this.placeholder=void 0,/** @type {Slide | undefined} */this.slide=void 0,this.displayedImageWidth=0,this.displayedImageHeight=0,this.width=Number(this.data.w)||Number(this.data.width)||0,this.height=Number(this.data.h)||Number(this.data.height)||0,this.isAttached=!1,this.hasSlide=!1,this.isDecoding=!1,/** @type {LoadState} */this.state=b.IDLE,this.data.type?this.type=this.data.type:this.data.src?this.type="image":this.type="html",this.instance.dispatch("contentInit",{content:this})}}/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */function td(t,e,i){let s;let n=e.createContentFromData(t,i),{options:o}=e;// as it might use srcset, and we need to define sizes
if(o){let a;s=new D(o,t,-1),a=e.pswp?e.pswp.viewportSize:A(o,e);let r=T(o,a,t,i);s.update(n.width,n.height,r)}return n.lazyLoad(),s&&n.setDisplayedSize(Math.ceil(n.width*s.initial),Math.ceil(n.height*s.initial)),n}class tp{/**
   * Lazy load nearby slides based on `preload` option.
   *
   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
   */updateLazy(t){let e;let{pswp:i}=this;if(i.dispatch("lazyLoad").defaultPrevented)return;let{preload:s}=i.options,n=void 0===t||t>=0;for(e=0;e<=s[1];e++)this.loadSlideByIndex(i.currIndex+(n?e:-e));// preload[0] - num items to preload in backward direction
for(e=1;e<=s[0];e++)this.loadSlideByIndex(i.currIndex+(n?-e:e))}/**
   * @param {number} initialIndex
   */loadSlideByIndex(t){let e=this.pswp.getLoopedIndex(t),i=this.getContentByIndex(e);// try to get cached content
!i&&// no cached content, so try to load from scratch:
(i=/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */function(t,e){let i=e.getItemData(t);if(!e.dispatch("lazyLoadSlide",{index:t,itemData:i}).defaultPrevented)return td(i,e,t)}(e,this.pswp))&&this.addToCache(i)}/**
   * @param {Slide} slide
   * @returns {Content}
   */getContentBySlide(t){let e=this.getContentByIndex(t.index);return e||(// create content if not found in cache
e=this.pswp.createContentFromData(t.data,t.index),this.addToCache(e)),e.setSlide(t),e}/**
   * @param {Content} content
   */addToCache(t){if(// move to the end of array
this.removeByIndex(t.index),this._cachedItems.push(t),this._cachedItems.length>this.limit){// Destroy the first content that's not attached
let t=this._cachedItems.findIndex(t=>!t.isAttached&&!t.hasSlide);if(-1!==t){let e=this._cachedItems.splice(t,1)[0];e.destroy()}}}/**
   * Removes an image from cache, does not destroy() it, just removes.
   *
   * @param {number} index
   */removeByIndex(t){let e=this._cachedItems.findIndex(e=>e.index===t);-1!==e&&this._cachedItems.splice(e,1)}/**
   * @param {number} index
   * @returns {Content | undefined}
   */getContentByIndex(t){return this._cachedItems.find(e=>e.index===t)}destroy(){this._cachedItems.forEach(t=>t.destroy()),this._cachedItems=[]}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,this.limit=Math.max(t.options.preload[0]+t.options.preload[1]+1,5),/** @type {Content[]} */this._cachedItems=[]}}/** @typedef {import("../photoswipe.js").default} PhotoSwipe *//** @typedef {import("../slide/slide.js").SlideData} SlideData *//**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */class tc extends tr{/**
   * Get total number of slides
   *
   * @returns {number}
   */getNumItems(){var t;let e=0,i=null===(t=this.options)||void 0===t?void 0:t.dataSource;i&&"length"in i?e=i.length:i&&"gallery"in i&&(i.items||(i.items=this._getGalleryDOMElements(i.gallery)),i.items&&(e=i.items.length));// legacy event, before filters were introduced
let s=this.dispatch("numItems",{dataSource:i,numItems:e});return this.applyFilters("numItems",s.numItems,i)}/**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */createContentFromData(t,e){return new tl(t,this,e)}/**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */getItemData(t){var e;let i=null===(e=this.options)||void 0===e?void 0:e.dataSource,s={};Array.isArray(i)?s=i[t]:i&&"gallery"in i&&(i.items||(i.items=this._getGalleryDOMElements(i.gallery)),s=i.items[t]);let n=s;n instanceof Element&&(n=this._domElementToItemData(n));// Dispatching the itemData event,
// it's a legacy verion before filters were introduced
let o=this.dispatch("itemData",{itemData:n||{},index:t});return this.applyFilters("itemData",o.itemData,t)}/**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */_getGalleryDOMElements(t){var e,i;return null!==(e=this.options)&&void 0!==e&&e.children||null!==(i=this.options)&&void 0!==i&&i.childSelector?/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */function(t,e,i=document){/** @type {HTMLElement[]} */let s=[];if(t instanceof Element)s=[t];else if(t instanceof NodeList||Array.isArray(t))s=Array.from(t);else{let n="string"==typeof t?t:e;n&&(s=Array.from(i.querySelectorAll(n)))}return s}(this.options.children,this.options.childSelector,t)||[]:[t]}/**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */_domElementToItemData(t){/** @type {SlideData} */let e={element:t},i=/** @type {HTMLAnchorElement} */"A"===t.tagName?t:t.querySelector("a");if(i){// src comes from data-pswp-src attribute,
// if it's empty link href is used
e.src=i.dataset.pswpSrc||i.href,i.dataset.pswpSrcset&&(e.srcset=i.dataset.pswpSrcset),e.width=i.dataset.pswpWidth?parseInt(i.dataset.pswpWidth,10):0,e.height=i.dataset.pswpHeight?parseInt(i.dataset.pswpHeight,10):0,e.w=e.width,e.h=e.height,i.dataset.pswpType&&(e.type=i.dataset.pswpType);let n=t.querySelector("img");if(n){var s;// msrc is URL to placeholder image that's displayed before large image is loaded
// by default it's displayed only for the first slide
e.msrc=n.currentSrc||n.src,e.alt=null!==(s=n.getAttribute("alt"))&&void 0!==s?s:""}(i.dataset.pswpCropped||i.dataset.cropped)&&(e.thumbCropped=!0)}return this.applyFilters("domItemData",e,t,i)}/**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */lazyLoadData(t,e){return td(t,this,e)}}/**
 * Manages opening and closing transitions of the PhotoSwipe.
 *
 * It can perform zoom, fade or no transition.
 */class tm{open(){this._prepareOpen(),this._start()}close(){if(this.isClosed||this.isClosing||this.isOpening)// for now do nothing,
// browsers aren't good at changing the direction of the CSS transition
return;let t=this.pswp.currSlide;this.isOpen=!1,this.isOpening=!1,this.isClosing=!0,this._duration=this.pswp.options.hideAnimationDuration,t&&t.currZoomLevel*t.width>=this.pswp.options.maxWidthToAnimate&&(this._duration=0),this._applyStartProps(),setTimeout(()=>{this._start()},this._croppedZoom?30:0)}/** @private */_prepareOpen(){if(this.pswp.off("firstZoomPan",this._prepareOpen),!this.isOpening){let t=this.pswp.currSlide;this.isOpening=!0,this.isClosing=!1,this._duration=this.pswp.options.showAnimationDuration,t&&t.zoomLevels.initial*t.width>=this.pswp.options.maxWidthToAnimate&&(this._duration=0),this._applyStartProps()}}/** @private */_applyStartProps(){var t,e;let{pswp:i}=this,s=this.pswp.currSlide,{options:n}=i;if("fade"===n.showHideAnimationType?(n.showHideOpacity=!0,this._thumbBounds=void 0):"none"===n.showHideAnimationType?(n.showHideOpacity=!1,this._duration=0,this._thumbBounds=void 0):this.isOpening&&i._initialThumbBounds?this._thumbBounds=i._initialThumbBounds:this._thumbBounds=this.pswp.getThumbBounds(),this._placeholder=null==s?void 0:s.getPlaceholderElement(),i.animations.stopAll(),this._useAnimation=!!(this._duration&&this._duration>50),this._animateZoom=!!this._thumbBounds&&(null==s?void 0:s.content.usePlaceholder())&&(!this.isClosing||!i.mainScroll.isShifted()),this._animateZoom?this._animateRootOpacity=null!==(t=n.showHideOpacity)&&void 0!==t&&t:(this._animateRootOpacity=!0,this.isOpening&&s&&(s.zoomAndPanToInitial(),s.applyCurrentZoomPan())),this._animateBgOpacity=!this._animateRootOpacity&&this.pswp.options.bgOpacity>.003,this._opacityElement=this._animateRootOpacity?i.element:i.bg,!this._useAnimation){this._duration=0,this._animateZoom=!1,this._animateBgOpacity=!1,this._animateRootOpacity=!0,this.isOpening&&(i.element&&(i.element.style.opacity=String(.003)),i.applyBgOpacity(1));return}this._animateZoom&&this._thumbBounds&&this._thumbBounds.innerRect?(// Properties are used when animation from cropped thumbnail
this._croppedZoom=!0,this._cropContainer1=this.pswp.container,this._cropContainer2=null===(e=this.pswp.currSlide)||void 0===e?void 0:e.holderElement,i.container&&(i.container.style.overflow="hidden",i.container.style.width=i.viewportSize.x+"px")):this._croppedZoom=!1,this.isOpening?(this._animateRootOpacity?(i.element&&(i.element.style.opacity=String(.003)),i.applyBgOpacity(1)):(this._animateBgOpacity&&i.bg&&(i.bg.style.opacity=String(.003)),i.element&&(i.element.style.opacity="1")),this._animateZoom&&(this._setClosedStateZoomPan(),this._placeholder&&(// tell browser that we plan to animate the placeholder
this._placeholder.style.willChange="transform",// elements that overlap it (such as icons over the thumbnail)
this._placeholder.style.opacity=String(.003)))):this.isClosing&&(i.mainScroll.itemHolders[0]&&(i.mainScroll.itemHolders[0].el.style.display="none"),i.mainScroll.itemHolders[2]&&(i.mainScroll.itemHolders[2].el.style.display="none"),this._croppedZoom&&0!==i.mainScroll.x&&(// shift the main scroller to zero position
i.mainScroll.resetPosition(),i.mainScroll.resize()))}/** @private */_start(){this.isOpening&&this._useAnimation&&this._placeholder&&"IMG"===this._placeholder.tagName?// we wait till the current slide image placeholder is decoded,
// but no longer than 250ms,
// and no shorter than 50ms
// (just using requestanimationframe is not enough in Firefox,
// for some reason)
new Promise(t=>{var e;let i=!1,s=!0;("decode"in(e=/** @type {HTMLImageElement} */this._placeholder)?e.decode().catch(()=>{}):e.complete?Promise.resolve(e):new Promise((t,i)=>{e.onload=()=>t(e),e.onerror=i})).finally(()=>{i=!0,s||t(!0)}),setTimeout(()=>{s=!1,i&&t(!0)},50),setTimeout(t,250)}).finally(()=>this._initiate()):this._initiate()}/** @private */_initiate(){var t,e;null===(t=this.pswp.element)||void 0===t||t.style.setProperty("--pswp-transition-duration",this._duration+"ms"),this.pswp.dispatch(this.isOpening?"openingAnimationStart":"closingAnimationStart"),this.pswp.dispatch(/** @type {'initialZoomIn' | 'initialZoomOut'} */"initialZoom"+(this.isOpening?"In":"Out")),null===(e=this.pswp.element)||void 0===e||e.classList.toggle("pswp--ui-visible",this.isOpening),this.isOpening?(this._placeholder&&(this._placeholder.style.opacity="1"),this._animateToOpenState()):this.isClosing&&this._animateToClosedState(),this._useAnimation||this._onAnimationComplete()}/** @private */_onAnimationComplete(){let{pswp:t}=this;if(this.isOpen=this.isOpening,this.isClosed=this.isClosing,this.isOpening=!1,this.isClosing=!1,t.dispatch(this.isOpen?"openingAnimationEnd":"closingAnimationEnd"),t.dispatch(/** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */"initialZoom"+(this.isOpen?"InEnd":"OutEnd")),this.isClosed)t.destroy();else if(this.isOpen){var e;this._animateZoom&&t.container&&(t.container.style.overflow="visible",t.container.style.width="100%"),null===(e=t.currSlide)||void 0===e||e.applyCurrentZoomPan()}}/** @private */_animateToOpenState(){let{pswp:t}=this;this._animateZoom&&(this._croppedZoom&&this._cropContainer1&&this._cropContainer2&&(this._animateTo(this._cropContainer1,"transform","translate3d(0,0,0)"),this._animateTo(this._cropContainer2,"transform","none")),t.currSlide&&(t.currSlide.zoomAndPanToInitial(),this._animateTo(t.currSlide.container,"transform",t.currSlide.getCurrentTransform()))),this._animateBgOpacity&&t.bg&&this._animateTo(t.bg,"opacity",String(t.options.bgOpacity)),this._animateRootOpacity&&t.element&&this._animateTo(t.element,"opacity","1")}/** @private */_animateToClosedState(){let{pswp:t}=this;this._animateZoom&&this._setClosedStateZoomPan(!0),this._animateBgOpacity&&t.bgOpacity>.01&&t.bg&&this._animateTo(t.bg,"opacity","0"),this._animateRootOpacity&&t.element&&this._animateTo(t.element,"opacity","0")}/**
   * @private
   * @param {boolean} [animate]
   */_setClosedStateZoomPan(t){if(!this._thumbBounds)return;let{pswp:e}=this,{innerRect:i}=this._thumbBounds,{currSlide:s,viewportSize:n}=e;if(this._croppedZoom&&i&&this._cropContainer1&&this._cropContainer2){let e=-n.x+(this._thumbBounds.x-i.x)+i.w,s=-n.y+(this._thumbBounds.y-i.y)+i.h,o=n.x-i.w,a=n.y-i.h;t?(this._animateTo(this._cropContainer1,"transform",w(e,s)),this._animateTo(this._cropContainer2,"transform",w(o,a))):(S(this._cropContainer1,e,s),S(this._cropContainer2,o,a))}s&&(v(s.pan,i||this._thumbBounds),s.currZoomLevel=this._thumbBounds.w/s.width,t?this._animateTo(s.container,"transform",s.getCurrentTransform()):s.applyCurrentZoomPan())}/**
   * @private
   * @param {HTMLElement} target
   * @param {'transform' | 'opacity'} prop
   * @param {string} propValue
   */_animateTo(t,e,i){if(!this._duration){t.style[e]=i;return}let{animations:s}=this.pswp,n={duration:this._duration,easing:this.pswp.options.easing,onComplete:()=>{s.activeAnimations.length||this._onAnimationComplete()},target:t};n[e]=i,s.startTransition(n)}/**
   * @param {PhotoSwipe} pswp
   */constructor(t){this.pswp=t,this.isClosed=!0,this.isOpen=!1,this.isClosing=!1,this.isOpening=!1,/**
     * @private
     * @type {number | false | undefined}
     */this._duration=void 0,/** @private */this._useAnimation=!1,/** @private */this._croppedZoom=!1,/** @private */this._animateRootOpacity=!1,/** @private */this._animateBgOpacity=!1,/**
     * @private
     * @type { HTMLDivElement | HTMLImageElement | null | undefined }
     */this._placeholder=void 0,/**
     * @private
     * @type { HTMLDivElement | undefined }
     */this._opacityElement=void 0,/**
     * @private
     * @type { HTMLDivElement | undefined }
     */this._cropContainer1=void 0,/**
     * @private
     * @type { HTMLElement | null | undefined }
     */this._cropContainer2=void 0,/**
     * @private
     * @type {Bounds | undefined}
     */this._thumbBounds=void 0,this._prepareOpen=this._prepareOpen.bind(this),t.on("firstZoomPan",this._prepareOpen)}}/**
 * @template T
 * @typedef {import('./types.js').Type<T>} Type<T>
 *//** @typedef {import('./slide/slide.js').SlideData} SlideData *//** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption *//** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData *//** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder *//** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap *//** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap *//** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
 *//**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
 *//** @typedef {{ x: number; y: number; id?: string | number }} Point *//** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding *//** @typedef {SlideData[]} DataSourceArray *//** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject *//** @typedef {DataSourceArray | DataSourceObject} DataSource *//** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn *//** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType *//** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule *//** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption *//**
 * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
 *//** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ *//**
 * @typedef {Object} PreparedPhotoSwipeOptions
 *
 * @prop {DataSource} [dataSource]
 * Pass an array of any items via dataSource option. Its length will determine amount of slides
 * (which may be modified further from numItems event).
 *
 * Each item should contain data that you need to generate slide
 * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
 *
 * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
 *
 * @prop {number} bgOpacity
 * Background backdrop opacity, always define it via this option and not via CSS rgba color.
 *
 * @prop {number} spacing
 * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
 *
 * @prop {boolean} allowPanToNext
 * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
 *
 * @prop {boolean} loop
 * If set to true you'll be able to swipe from the last to the first image.
 * Option is always false when there are less than 3 slides.
 *
 * @prop {boolean} [wheelToZoom]
 * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
 *
 * @prop {boolean} pinchToClose
 * Pinch touch gesture to close the gallery.
 *
 * @prop {boolean} closeOnVerticalDrag
 * Vertical drag gesture to close the PhotoSwipe.
 *
 * @prop {Padding} [padding]
 * Slide area padding (in pixels).
 *
 * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
 * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
 *
 * @prop {number | false} hideAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} showAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} zoomAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {string} easing
 * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
 *
 * @prop {boolean} escKey
 * Esc key to close.
 *
 * @prop {boolean} arrowKeys
 * Left/right arrow keys for navigation.
 *
 * @prop {boolean} returnFocus
 * Restore focus the last active element after PhotoSwipe is closed.
 *
 * @prop {boolean} clickToCloseNonZoomable
 * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
 *
 * @prop {ActionType | ActionFn | false} imageClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} bgClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} tapAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} doubleTapAction
 * Refer to click and tap actions page.
 *
 * @prop {number} preloaderDelay
 * Delay before the loading indicator will be displayed,
 * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
 *
 * @prop {string} indexIndicatorSep
 * Used for slide count indicator ("1 of 10 ").
 *
 * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
 * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
 *
 * @prop {string} errorMsg
 * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
 *
 * @prop {[number, number]} preload
 * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
 * first one - number of items to preload before the current image, second one - after the current image.
 * Two nearby images are always loaded.
 *
 * @prop {string} [mainClass]
 * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
 * Example on Styling page.
 *
 * @prop {HTMLElement} [appendToEl]
 * Element to which PhotoSwipe dialog will be appended when it opens.
 *
 * @prop {number} maxWidthToAnimate
 * Maximum width of image to animate, if initial rendered image width
 * is larger than this value - the opening/closing transition will be automatically disabled.
 *
 * @prop {string} [closeTitle]
 * Translating
 *
 * @prop {string} [zoomTitle]
 * Translating
 *
 * @prop {string} [arrowPrevTitle]
 * Translating
 *
 * @prop {string} [arrowNextTitle]
 * Translating
 *
 * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
 * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
 * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
 *
 * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
 *
 * @prop {number} index
 * Defines start slide index.
 *
 * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
 *
 * @prop {boolean} [arrowPrev]
 * @prop {boolean} [arrowNext]
 * @prop {boolean} [zoom]
 * @prop {boolean} [close]
 * @prop {boolean} [counter]
 *
 * @prop {string} [arrowPrevSVG]
 * @prop {string} [arrowNextSVG]
 * @prop {string} [zoomSVG]
 * @prop {string} [closeSVG]
 * @prop {string} [counterSVG]
 *
 * @prop {string} [arrowPrevTitle]
 * @prop {string} [arrowNextTitle]
 * @prop {string} [zoomTitle]
 * @prop {string} [closeTitle]
 * @prop {string} [counterTitle]
 *
 * @prop {ZoomLevelOption} [initialZoomLevel]
 * @prop {ZoomLevelOption} [secondaryZoomLevel]
 * @prop {ZoomLevelOption} [maxZoomLevel]
 *
 * @prop {boolean} [mouseMovePan]
 * @prop {Point | null} [initialPointerPos]
 * @prop {boolean} [showHideOpacity]
 *
 * @prop {PhotoSwipeModuleOption} [pswpModule]
 * @prop {() => Promise<any>} [openPromise]
 * @prop {boolean} [preloadFirstSlide]
 * @prop {ElementProvider} [gallery]
 * @prop {string} [gallerySelector]
 * @prop {ElementProvider} [children]
 * @prop {string} [childSelector]
 * @prop {string | false} [thumbSelector]
 *//** @type {PreparedPhotoSwipeOptions} */let tu={allowPanToNext:!0,spacing:.1,loop:!0,pinchToClose:!0,closeOnVerticalDrag:!0,hideAnimationDuration:333,showAnimationDuration:333,zoomAnimationDuration:333,escKey:!0,arrowKeys:!0,returnFocus:!0,maxWidthToAnimate:4e3,clickToCloseNonZoomable:!0,imageClickAction:"zoom-or-close",bgClickAction:"close",tapAction:"toggle-controls",doubleTapAction:"zoom",indexIndicatorSep:" / ",preloaderDelay:2e3,bgOpacity:.8,index:0,errorMsg:"The image cannot be loaded",preload:[1,2],easing:"cubic-bezier(.4,0,.22,1)"};/**
 * PhotoSwipe Core
 */class tv extends tc{/** @returns {boolean} */init(){if(this.isOpen||this.isDestroying)return!1;this.isOpen=!0,this.dispatch("init"),this.dispatch("beforeOpen"),this._createMainStructure();let t="pswp--open";return this.gestures.supportsTouch&&(t+=" pswp--touch"),this.options.mainClass&&(t+=" "+this.options.mainClass),this.element&&(this.element.className+=" "+t),this.currIndex=this.options.index||0,this.potentialIndex=this.currIndex,this.dispatch("firstUpdate"),// initialize scroll wheel handler to block the scroll
this.scrollWheel=new K(this),(Number.isNaN(this.currIndex)||this.currIndex<0||this.currIndex>=this.getNumItems())&&(this.currIndex=0),this.gestures.supportsTouch||this.mouseDetected(),// causes forced synchronous layout
this.updateSize(),this.offset.y=window.pageYOffset,this._initialItemData=this.getItemData(this.currIndex),this.dispatch("gettingData",{index:this.currIndex,data:this._initialItemData,slide:void 0}),this._initialThumbBounds=this.getThumbBounds(),this.dispatch("initialLayout"),this.on("openingAnimationEnd",()=>{let{itemHolders:t}=this.mainScroll;// Add content to the previous and next slide
t[0]&&(t[0].el.style.display="block",this.setContent(t[0],this.currIndex-1)),t[2]&&(t[2].el.style.display="block",this.setContent(t[2],this.currIndex+1)),this.appendHeavy(),this.contentLoader.updateLazy(),this.events.add(window,"resize",this._handlePageResize.bind(this)),this.events.add(window,"scroll",this._updatePageScrollOffset.bind(this)),this.dispatch("bindEvents")}),this.mainScroll.itemHolders[1]&&this.setContent(this.mainScroll.itemHolders[1],this.currIndex),this.dispatch("change"),this.opener.open(),this.dispatch("afterInit"),!0}/**
   * Get looped slide index
   * (for example, -1 will return the last slide)
   *
   * @param {number} index
   * @returns {number}
   */getLoopedIndex(t){let e=this.getNumItems();return this.options.loop&&(t>e-1&&(t-=e),t<0&&(t+=e)),f(t,0,e-1)}appendHeavy(){this.mainScroll.itemHolders.forEach(t=>{var e;null===(e=t.slide)||void 0===e||e.appendHeavy()})}/**
   * Change the slide
   * @param {number} index New index
   */goTo(t){this.mainScroll.moveIndexBy(this.getLoopedIndex(t)-this.potentialIndex)}/**
   * Go to the next slide.
   */next(){this.goTo(this.potentialIndex+1)}/**
   * Go to the previous slide.
   */prev(){this.goTo(this.potentialIndex-1)}/**
   * @see slide/slide.js zoomTo
   *
   * @param {Parameters<Slide['zoomTo']>} args
   */zoomTo(...t){var e;null===(e=this.currSlide)||void 0===e||e.zoomTo(...t)}/**
   * @see slide/slide.js toggleZoom
   */toggleZoom(){var t;null===(t=this.currSlide)||void 0===t||t.toggleZoom()}/**
   * Close the gallery.
   * After closing transition ends - destroy it
   */close(){this.opener.isOpen&&!this.isDestroying&&(this.isDestroying=!0,this.dispatch("close"),this.events.removeAll(),this.opener.close())}/**
   * Destroys the gallery:
   * - instantly closes the gallery
   * - unbinds events,
   * - cleans intervals and timeouts
   * - removes elements from DOM
   */destroy(){var t;if(!this.isDestroying){this.options.showHideAnimationType="none",this.close();return}this.dispatch("destroy"),this._listeners={},this.scrollWrap&&(this.scrollWrap.ontouchmove=null,this.scrollWrap.ontouchend=null),null===(t=this.element)||void 0===t||t.remove(),this.mainScroll.itemHolders.forEach(t=>{var e;null===(e=t.slide)||void 0===e||e.destroy()}),this.contentLoader.destroy(),this.events.removeAll()}/**
   * Refresh/reload content of a slide by its index
   *
   * @param {number} slideIndex
   */refreshSlideContent(t){this.contentLoader.removeByIndex(t),this.mainScroll.itemHolders.forEach((e,i)=>{var s,n,o;let a=(null!==(s=null===(n=this.currSlide)||void 0===n?void 0:n.index)&&void 0!==s?s:0)-1+i;this.canLoop()&&(a=this.getLoopedIndex(a)),a===t&&(// set the new slide content
this.setContent(e,t,!0),1===i&&(this.currSlide=e.slide,null===(o=e.slide)||void 0===o||o.setIsActive(!0)))}),this.dispatch("change")}/**
   * Set slide content
   *
   * @param {ItemHolder} holder mainScroll.itemHolders array item
   * @param {number} index Slide index
   * @param {boolean} [force] If content should be set even if index wasn't changed
   */setContent(t,e,i){if(this.canLoop()&&(e=this.getLoopedIndex(e)),t.slide){if(t.slide.index===e&&!i)// this could be common when just three slides are used
return;// destroy previous slide
t.slide.destroy(),t.slide=void 0}// exit if no loop and index is out of bounds
if(!this.canLoop()&&(e<0||e>=this.getNumItems()))return;let s=this.getItemData(e);t.slide=new O(s,e,this),e===this.currIndex&&(this.currSlide=t.slide),t.slide.append(t.el)}/** @returns {Point} */getViewportCenterPoint(){return{x:this.viewportSize.x/2,y:this.viewportSize.y/2}}/**
   * Update size of all elements.
   * Executed on init and on page resize.
   *
   * @param {boolean} [force] Update size even if size of viewport was not changed.
   */updateSize(t){// let item;
// let itemIndex;
if(this.isDestroying)// (to avoid errors, as resize event might be delayed)
return;//const newWidth = this.scrollWrap.clientWidth;
//const newHeight = this.scrollWrap.clientHeight;
let e=A(this.options,this);!t&&y(e,this._prevViewportSize)||(//this._prevViewportSize.x = newWidth;
//this._prevViewportSize.y = newHeight;
v(this._prevViewportSize,e),this.dispatch("beforeResize"),v(this.viewportSize,this._prevViewportSize),this._updatePageScrollOffset(),this.dispatch("viewportSize"),// and don't re-calculate size on inital size update
this.mainScroll.resize(this.opener.isOpen),!this.hasMouse&&window.matchMedia("(any-hover: hover)").matches&&this.mouseDetected(),this.dispatch("resize"))}/**
   * @param {number} opacity
   */applyBgOpacity(t){this.bgOpacity=Math.max(t,0),this.bg&&(this.bg.style.opacity=String(this.bgOpacity*this.options.bgOpacity))}/**
   * Whether mouse is detected
   */mouseDetected(){if(!this.hasMouse){var t;this.hasMouse=!0,null===(t=this.element)||void 0===t||t.classList.add("pswp--has_mouse")}}/**
   * Page resize event handler
   *
   * @private
   */_handlePageResize(){this.updateSize(),/iPhone|iPad|iPod/i.test(window.navigator.userAgent)&&setTimeout(()=>{this.updateSize()},500)}/**
   * Page scroll offset is used
   * to get correct coordinates
   * relative to PhotoSwipe viewport.
   *
   * @private
   */_updatePageScrollOffset(){this.setScrollOffset(0,window.pageYOffset)}/**
   * @param {number} x
   * @param {number} y
   */setScrollOffset(t,e){this.offset.x=t,this.offset.y=e,this.dispatch("updateScrollOffset")}/**
   * Create main HTML structure of PhotoSwipe,
   * and add it to DOM
   *
   * @private
   */_createMainStructure(){// root DOM element of PhotoSwipe (.pswp)
this.element=u("pswp","div"),this.element.setAttribute("tabindex","-1"),this.element.setAttribute("role","dialog"),this.template=this.element,// as animating opacity is faster than animating rgba()
this.bg=u("pswp__bg","div",this.element),this.scrollWrap=u("pswp__scroll-wrap","section",this.element),this.container=u("pswp__container","div",this.scrollWrap),this.scrollWrap.setAttribute("aria-roledescription","carousel"),this.container.setAttribute("aria-live","off"),this.container.setAttribute("id","pswp__items"),this.mainScroll.appendHolders(),this.ui=new to(this),this.ui.init(),(this.options.appendToEl||document.body).appendChild(this.element)}/**
   * Get position and dimensions of small thumbnail
   *   {x:,y:,w:}
   *
   * Height is optional (calculated based on the large image)
   *
   * @returns {Bounds | undefined}
   */getThumbBounds(){return(/**
 * Get dimensions of thumbnail image
 * (click on which opens photoswipe or closes photoswipe to)
 *
 * @param {number} index
 * @param {SlideData} itemData
 * @param {PhotoSwipe} instance PhotoSwipe instance
 * @returns {Bounds | undefined}
 */function(t,e,i){let s,n;// legacy event, before filters were introduced
let o=i.dispatch("thumbBounds",{index:t,itemData:e,instance:i});// @ts-expect-error
if(o.thumbBounds)return o.thumbBounds;let{element:a}=e;if(a&&!1!==i.options.thumbSelector){let t=i.options.thumbSelector||"img";n=a.matches(t)?a:/** @type {HTMLElement | null} */a.querySelector(t)}return(n=i.applyFilters("thumbEl",n,e,t))&&(s=e.thumbCropped?/**
 * @param {HTMLElement} el
 * @param {number} imageWidth
 * @param {number} imageHeight
 * @returns Bounds
 */function(t,e,i){let s=t.getBoundingClientRect(),n=s.width/e,o=s.height/i,a=n>o?n:o,r=(s.width-e*a)/2,h=(s.height-i*a)/2,l={x:s.left+r,y:s.top+h,w:e*a};// fill image into the area
return(// relative to the image
l.innerRect={w:s.width,h:s.height,x:r,y:h},l)}(n,e.width||e.w||0,e.height||e.h||0):/** @typedef {import('./slide.js').SlideData} SlideData *//** @typedef {import('../photoswipe.js').default} PhotoSwipe *//** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds *//**
 * @param {HTMLElement} el
 * @returns Bounds
 */function(t){let e=t.getBoundingClientRect();return{x:e.left,y:e.top,w:e.width}}(n)),i.applyFilters("thumbBounds",s,e,t)}(this.currIndex,this.currSlide?this.currSlide.data:this._initialItemData,this))}/**
   * If the PhotoSwipe can have continuous loop
   * @returns Boolean
   */canLoop(){return this.options.loop&&this.getNumItems()>2}/**
   * @private
   * @param {PhotoSwipeOptions} options
   * @returns {PreparedPhotoSwipeOptions}
   */_prepareOptions(t){/** @type {PreparedPhotoSwipeOptions} */return window.matchMedia("(prefers-reduced-motion), (update: slow)").matches&&(t.showHideAnimationType="none",t.zoomAnimationDuration=0),function(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{},s=Object.keys(i);"function"==typeof Object.getOwnPropertySymbols&&(s=s.concat(Object.getOwnPropertySymbols(i).filter(function(t){return Object.getOwnPropertyDescriptor(i,t).enumerable}))),s.forEach(function(e){var s;s=i[e],e in t?Object.defineProperty(t,e,{value:s,enumerable:!0,configurable:!0,writable:!0}):t[e]=s})}return t}({},tu,t)}/**
   * @param {PhotoSwipeOptions} [options]
   */constructor(t){super(),this.options=this._prepareOptions(t||{}),/**
     * offset of viewport relative to document
     *
     * @type {Point}
     */this.offset={x:0,y:0},/**
     * @type {Point}
     * @private
     */this._prevViewportSize={x:0,y:0},/**
     * Size of scrollable PhotoSwipe viewport
     *
     * @type {Point}
     */this.viewportSize={x:0,y:0},/**
     * background (backdrop) opacity
     */this.bgOpacity=1,this.currIndex=0,this.potentialIndex=0,this.isOpen=!1,this.isDestroying=!1,this.hasMouse=!1,/**
     * @private
     * @type {SlideData}
     */this._initialItemData={},/** @type {Bounds | undefined} */this._initialThumbBounds=void 0,/** @type {HTMLDivElement | undefined} */this.topBar=void 0,/** @type {HTMLDivElement | undefined} */this.element=void 0,/** @type {HTMLDivElement | undefined} */this.template=void 0,/** @type {HTMLDivElement | undefined} */this.container=void 0,/** @type {HTMLElement | undefined} */this.scrollWrap=void 0,/** @type {Slide | undefined} */this.currSlide=void 0,this.events=new L,this.animations=new j,this.mainScroll=new B(this),this.gestures=new N(this),this.opener=new tm(this),this.keyboard=new q(this),this.contentLoader=new tp(this)}}customElements.get("product-template")||customElements.define("product-template",class extends HTMLElement{init(){this.initSlider(),this.initZoom(),this.zoom.forEach(t=>{t.addEventListener("click",e=>{e.preventDefault(),gtag("event","product_thumbnail_zoom",{target:`${t.href}`})})}),window.addEventListener("resize",()=>{this.initZoom(),$(this.slider).hasClass("slick-initialized")&&$(this.slider).slick("setPosition"),$(this.sliderNav).hasClass("slick-initialized")&&$(this.sliderNav).slick("setPosition")}),this.initQuantity(),this.initProperties(),this.initStickyForm(),this.initStickyAddToCart(),this.initDescToggle(),productReviews()}initDescToggle(){null!==this.descToggle&&this.descToggle.on("click",t=>{t.preventDefault(),this.desc.toggleClass("is-short")})}initStickyForm(){null!=this.productStickyForm&&window.addEventListener("scroll",()=>{this.addToCart.getBoundingClientRect().y-document.querySelector("#shopify-section-header").offsetHeight+45<0?this.productStickyForm.classList.add("is-show"):this.productStickyForm.classList.remove("is-show")})}initStickyAddToCart(){null!=this.stickyAddToCart&&this.stickyAddToCart.addEventListener("click",()=>{this.stickyAddToCart.classList.contains("has-variants")?this.addToCartForm.scrollIntoView({behavior:"smooth",block:"center"}):this.addToCart.click()})}initProperties(){this.input_scent.forEach(t=>{t.addEventListener("change",()=>{this.scent_ttl.innerHTML=t.value,this.scent_select.value=t.value,this.scent_select.dispatchEvent(new Event("change"))})}),this.input_color.forEach(t=>{t.addEventListener("change",()=>{this.scent_ttl.innerHTML=t.value,this.scent_select.value=t.value,this.scent_select.dispatchEvent(new Event("change"))})})}initQuantity(){this.minus.forEach(t=>{t.addEventListener("click",()=>{let t=this.querySelector('input[name="quantity"]'),e=this.querySelectorAll(".add-to-cart"),i=parseInt(t.value,10)-1;i=i<1?1:i,t.value=i,t.dispatchEvent(new Event("change")),e.forEach(e=>{e.innerHTML=t.value})})}),this.plus.forEach(t=>{t.addEventListener("click",()=>{let t=this.querySelector('input[name="quantity"]'),e=this.querySelectorAll(".add-to-cart"),i=parseInt(t.value,10)+1;6743714463842==this.productId&&i>4&&(i=4),t.value=i,t.dispatchEvent(new Event("change")),e.forEach(e=>{e.innerHTML=t.value})})})}initZoom(){$(window).width()>767?null!==this.lightbox&&(this.lightbox.destroy(),this.lightbox=null):null==this.lightbox&&null==this.closest(".js-quick-view-modal")&&(this.lightbox=new m({gallery:this.selectors.slider,children:this.selectors.zoom,showHideAnimationType:"fade",pswpModule:tv}),this.lightbox.init())}pauseAllMedia(){document.querySelectorAll(".js-youtube").forEach(t=>{t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")}),document.querySelectorAll(".js-vimeo").forEach(t=>{t.contentWindow.postMessage('{"method":"pause"}',"*")}),document.querySelectorAll("video:not(.product-half__video):not(.sr-media__img)").forEach(t=>t.pause())}initSlider(){setTimeout(()=>{function t(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],t("js",new Date),t("config","G-D1FCZC0PFH"),$(this.slider).on("beforeChange",(t,e,i,s)=>{this.pauseAllMedia(),$(this.sliderNav).find(".product-slider__nav-slide").removeClass("is-active"),$(this.sliderNav).find(".product-slider__nav-slide[data-index="+s+"]").addClass("is-active")}),$(this.slider).on("afterChange",(e,i,s)=>{t("event","product_gallery_slide_view",{filename:i.$slides[s].querySelector("img").src.split("?")[0]})}),$(this.slider).on("init",(e,i)=>{t("event","product_gallery_slide_view",{filename:i.$slides[i.currentSlide].querySelector("img").src.split("?")[0]})}),$(this.slider).slick({slidesToShow:1,slidesToScroll:1,arrows:!0,infinite:!1,dots:!1,slide:this.selectors.slide,asNavFor:this.selectors.sliderNav,adaptiveHeight:!0,initialSlide:parseInt($(this.slider).attr("data-start"),10)}),window.productSlider=this.slider,$(this.sliderNav).slick({slidesToShow:$(this.sliderNav).find(".slide").length>4?4:$(this.sliderNav).find(".slide").length,slidesToScroll:1,infinite:!1,asNavFor:this.selectors.slider,arrows:!0,dots:!1,focusOnSelect:!0,initialSlide:parseInt($(this.slider).attr("data-start"),10),responsive:[{breakpoint:767,settings:{slidesToShow:$(this.sliderNav).find(".slide").length>4?4:$(this.sliderNav).find(".slide").length,slidesToScroll:1,variableWidth:!0}}]})},300)}constructor(){super(),this.selectors={slider:".js-product-slider",sliderNav:".js-product-slider-nav",slide:".js-product-slide",zoom:".js-product-slider-zoom",input_scent:'input[name="scent"]',input_color:'input[name="color"]',scent_ttl:".product-details__options--color .select__title .selected-scent",scent_select:".product-details__options--color select.single-option-selector",minus:".minus",plus:".plus",stickyAddToCart:".js-sticky-add-to-cart",addToCart:".js-add-to-cart",productStickyForm:".js-product-sticky-form",addToCartForm:'form[action="/cart/add"]',descToggle:".js-product-desc-toggle",desc:".js-product-desc"},this.descToggle=$(this.selectors.descToggle),this.desc=$(this.selectors.desc),this.slider=this.querySelector(this.selectors.slider),this.sliderNav=this.querySelector(this.selectors.sliderNav),this.zoom=this.querySelectorAll(this.selectors.zoom),this.input_scent=this.querySelectorAll(this.selectors.input_scent),this.input_color=this.querySelectorAll(this.selectors.input_color),this.scent_ttl=this.querySelector(this.selectors.scent_ttl),this.scent_select=this.querySelector(this.selectors.scent_select),this.minus=this.querySelectorAll(this.selectors.minus),this.plus=this.querySelectorAll(this.selectors.plus),this.stickyAddToCart=this.querySelector(this.selectors.stickyAddToCart),this.productStickyForm=this.querySelector(this.selectors.productStickyForm),this.addToCart=this.querySelector(this.selectors.addToCart),this.addToCartForm=this.querySelector(this.selectors.addToCartForm),this.productId=parseInt(this.getAttribute("product-id"),10),this.lightbox=null,this.init()}})}();